var pathShfor3D = meta.page.pageType;

if (pathShfor3D == 'product') {
    // var previewBlockUl = document.querySelector('preview-block#MediaGallery-Livearf ul.product__media-list')
    var threeDView_Preview = document.querySelector('#threeDView-preview');
    var galleryView_preview = document.getElementById('galleryView-preview');
    var container = document.querySelector('#threeDView-preview .product-media-container');
    if (container) {
        container.style.display = "none";
    }
    // if(previewBlockUl){
    //     threeDView_Preview = document.createElement('li');
    //     threeDView_Preview.id = 'threeDView_Preview';
    //     threeDView_Preview.style.width = '100%';
    //     threeDView_Preview.classList = 'product__media-item grid__item slider__slide is-active scroll-trigger animate--fade-in larf__media-item hideBlock'
    //     previewBlockUl.appendChild(threeDView_Preview)
    // }
    // const threeDButton = document.getElementById('threeDView');
    // const frameView_preview = document.getElementById('frameView-preview');
    // const roomView_preview = document.getElementById('roomView-preview');
    const contentBlock = document.querySelector('#threeDView_Preview');

    // threeDButton.addEventListener('click', function() {
    //     // 4. Remove 'hideBlock' from the target element
        if (contentBlock) {
    //         frameView_preview.classList.add('hideBlock');
    //         roomView_preview.classList.add('hideBlock');
    //         contentBlock.classList.remove('hideBlock');
                galleryView_preview.classList.add('hideBlock')
        }
    // });
    console.log("inside product the js file")
   if (document.getElementsByTagName('livearf-variant-selects')[0]) {
    console.log("34");
        // loadjscssfile("https://shop.livearf.com/lb4b-shop/dist/css/livevue-template.min.css", "css");
        // loadjscssfile("https://lb4b-shop.in.ngrok.io/styles/livevue-template.css", "css")
        var IMAGE_URL;
        var originalImage;
        var selectedOptions;
        var selc_FrameWidth;
        var selc_FrameDepth;
        var selc_FrameRabbetDepth;
        var rollingMesh;
        var isCustomSizeBtn = document.querySelector('variant-selects input[value="Custom Size"]')
        var uploadOption = document.getElementsByClassName('uploadYourImage')[0];
        var isCustomSizeActive = false;
        var isGenerateBtnClicked = false;
        isManualCrop = false;
        var AluMountProfile;
        var croppedDataV2;
        var isUnrolling = false;
        var unrollTimer = null;
        if(!uploadOption){
            IMAGE_URL = mainImage.src;
        }

        var FRAME_PROFILE = '';
        // console.log('here us the file loaded')
        document.querySelector('#frameView-preview').style.width = '100%'
        mainFramepreviewArea.style.width = '100%';
        
        var spatial3D = document.createElement('div');
        spatial3D.id = 'spatial3D';
        if (window.matchMedia("(max-width: 600px)").matches) {
            mainFramepreviewArea.style.position = 'relative';
            spatial3D.style.width = '400px';
            spatial3D.style.height = '400px';
            spatial3D.style.position = 'absolute';
            spatial3D.style.left = '50%';
            spatial3D.style.top = '50%';
            spatial3D.style.transform = 'translate(-50%, -50%)';

        } else {
            spatial3D.style.maxWidth = '600px';
            spatial3D.style.width = '100%';
            spatial3D.style.height = '600px';
        }
        threeDView_Preview.append(spatial3D)
        // Global array to store animations for the exporter
        var activeAnimations = [];
        var scene, renderer, exportGroup, exporter, modelViewer, textureLoader, camera;
        var loadedImageTexture = null;
        var loadedFrameTexture = null;
        var rawImage = null;
        var mixer; // Animation mixer
        // *** ADD THIS LINE ***
        var clock = new THREE.Clock();
        var isPrintOnly = false;
        var mats = {};
        // Default Config
        var currentConfig = {
            type: 'paper-print',
            unit: currentSize.unit,
            width: currentSize.width, height: currentSize.height,
            mat1: 0, mat2: 0, frame: currentSize.frameThickness,
            frameDepth: 0,
            rabbetDepth: 0,
            rabbetWidth: 0,
            wrap: 'normal',
            floater: false,
            hasGlass: false
        };
        var unrollDuration;
        var frameFrontTexture;
        var frameSideTexture;
        var hasFrame = false;
        var hasLED = false;
        var isContourFrame = false;
        var textureCache = {};
        IMAGE_URL = mainImage.src;
        var currentFrameUrl = 'https://dl.polyhaven.org/file/ph-assets/Textures/jpg/1k/wood_table_001/wood_table_001_diff_1k.jpg';
        var silverTextureUrl = 'https://cdn.shopify.com/s/files/1/0788/7758/9753/files/silverTexture_0e2aee14-a7be-424f-bfa2-7b5b47f1a070.jpg?v=1770303811';

        var unitMultipliers = {
            "cm": 0.01,     // Divide by 100
            "mm": 0.001,    // Divide by 1000
            "inch": 0.0254, // 1 inch = 2.54cm = 0.0254 meters
            "in": 0.0254    // Handle "in" abbreviation just in case
        };

        // --- 1. CREATE LOADER UI (Text + Bar) ---
        var loaderDiv = document.createElement('div');
        loaderDiv.id = 'ar-loader-overlay';
        // Updated HTML with the Status Message container
        loaderDiv.innerHTML = `
            <div class="progress-text" id="progress-text">0%</div>
            <div class="progress-track">
                <div class="progress-fill" id="progress-fill"></div>
            </div>
            <div id="loader-status-msg" style="margin-top: 10px; font-size: 12px; color: #666;">
                Generating 3D Model...
            </div>
        `;
        // Hide it initially until a change is triggered
        loaderDiv.style.display = 'none';
        threeDView_Preview.append(loaderDiv);

        // References to update them later
        const progressFill = loaderDiv.querySelector('#progress-fill');
        const progressText = loaderDiv.querySelector('#progress-text');

        function getUnitFactor(unitString) {
            // 1. Sanitize input (lowercase, remove spaces)
            const unit = unitString ? unitString.toLowerCase().trim() : 'cm';

            // 2. Return factor or default to cm (0.01) if invalid
            return unitMultipliers[unit] || 0.01;
        }

        // --- INIT FUNCTION ---
        function init() {
            scene = new THREE.Scene();
            exportGroup = new THREE.Group();
            scene.add(exportGroup);

            // Camera setup needed for rendering (even if not visible)
            camera = new THREE.PerspectiveCamera(60, 1, 0.1, 2000);
            camera.position.z = 1;

            // Renderer
            renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
            renderer.outputEncoding = THREE.sRGBEncoding;
            renderer.toneMapping = THREE.ACESFilmicToneMapping;
            renderer.setSize(600, 600); // Set initial safe size

            // Hide the canvas, we only use it for calculation/export
            renderer.domElement.style.display = 'none';
            renderer.domElement.style.position = 'absolute';
            renderer.domElement.style.top = '0';
            renderer.domElement.style.zIndex = '999'; // Force it on top
            spatial3D.appendChild(renderer.domElement);

            // 4. Controls: Enable Orbiting
            // controls = new THREE.OrbitControls(camera, renderer.domElement);
            // controls.enableDamping = true;

            // Add Axis Helper (Size 0.5 meters)
            const axesHelper = new THREE.AxesHelper(0.5);
            scene.add(axesHelper);

            // Optional: Add a Grid Helper to see the "floor"
            const gridHelper = new THREE.GridHelper(1, 10);
            scene.add(gridHelper);

            // Lights
            const ambient = new THREE.AmbientLight(0xffffff, 0.6);
            scene.add(ambient);
            const dirLight = new THREE.DirectionalLight(0xffffff, 1.0);
            dirLight.position.set(2, 2, 2);
            scene.add(dirLight);

            // Model Viewer
            modelViewer = document.createElement('model-viewer');
            modelViewer.style.width = '100%';
            modelViewer.style.height = '100%';
            modelViewer.setAttribute('ar', '');
            modelViewer.setAttribute('ar-modes', 'webxr scene-viewer quick-look');
            modelViewer.setAttribute('animation-loop', 'false');
            modelViewer.setAttribute('camera-controls', '');
            modelViewer.setAttribute('auto-scale', '');
            modelViewer.setAttribute('shadow-intensity', '2.5');
            modelViewer.setAttribute('ar-placement', 'floor');
            modelViewer.setAttribute('touch-action', 'none');
            modelViewer.setAttribute('environment-image', 'https://dl.polyhaven.org/file/ph-assets/HDRIs/hdr/1k/brown_photostudio_02_1k.hdr');
            modelViewer.setAttribute('loading', 'eager'); // Start rendering immediately
            modelViewer.setAttribute('poster-color', 'transparent'); // No white flash
            modelViewer.autoplay = false;
            modelViewer.loop = false;
            // Ensure model viewer is visible
            modelViewer.style.display = 'block';
            spatial3D.appendChild(modelViewer);

            exporter = new THREE.GLTFExporter();
            textureLoader = new THREE.TextureLoader();
            textureLoader.setCrossOrigin('anonymous');

            initMaterials();
            animate();
            loadResources();
            // Start Loading Process
            // Delay slightly to ensure DOM is ready
            // setTimeout(() => {
            //     loadResources();
            // }, 1000);

            window.addEventListener('resize', onWindowResize, false);
        }

        function initMaterials() {
            mats.mat1Material = new THREE.MeshStandardMaterial({ color: 0xffffff, roughness: 1.0, metalness: 0.0 });
            mats.mat2Material = new THREE.MeshStandardMaterial({ color: 0x000000, roughness: 1.0, metalness: 0.0 });
            mats.frame = new THREE.MeshStandardMaterial({ color: 0xffffff, roughness: 0.6, metalness: 0.0 });
            mats.backing = new THREE.MeshBasicMaterial({ color: 0x666666 });

            // mats.glass = new THREE.MeshPhysicalMaterial({
            //     color: 0xffffff, metalness: 0.0, roughness: 0.3,
            //     transmission: 0.0, transparent: true, opacity: 0.10, ior: 1.5, clearcoat: 1.0, clearcoatRoughness: 0.0,
            //     side: THREE.DoubleSide, envMapIntensity: 1.0, depthWrite: false
            // });
            // mats.glass = new THREE.MeshPhysicalMaterial({
            //     color: 0xffffff,
            //     metalness: 0.0,
            //     roughness: 0.02,          // Very smooth for clarity
            //     transmission: 0.95,       // Allow most light through
            //     thickness: 0.05,          // Physical depth
            //     transparent: true,        // Required for renderOrder and opacity
            //     opacity: 0.4,             // Fallback: If transmission fails, this ensures visibility
            //     ior: 1.49,                // Acrylic index of refraction
            //     reflectivity: 0.5,
            //     clearcoat: 1.0,
            //     side: THREE.FrontSide,    // Rendering only front faces often makes it clearer
            //     depthWrite: false         // Prevents the block from occluding the image
            // });

            mats.glass = new THREE.MeshPhysicalMaterial({
                color: 0xffffff,
                metalness: 0.0,
                roughness: 0.01,           // Keep it very smooth for that polished look
                transmission: 1.0,        // Full light passthrough
                ior: 2.0,                // Accurate index of refraction for Acrylic
                dispersion: 20.0,          // The "Rainbow" effect on edges (0 to 50 range)
                transparent: true,
                opacity: 0.3,
                envMapIntensity: 3.0,     // BOOST reflections (adjust 1.0 -> 3.0 based on preference)
                clearcoat: 0.0,           // Extra layer of gloss
                depthWrite: true,         // Better for thick blocks
                side: THREE.FrontSide
            });

            mats.metal = new THREE.MeshStandardMaterial({ color: 0xffffff, roughness: 0.2, metalness: 0.6 });
            mats.chrome = new THREE.MeshStandardMaterial({ color: 0xaaaaaa, roughness: 0.1, metalness: 1.0 });
            mats.shadowGap = new THREE.MeshBasicMaterial({ color: 0x111111 });
        }

        function loadResources() {
            return new Promise((resolve) => {
                if (currentFrameUrl && currentFrameUrl !== '') {
                    textureLoader.load(currentFrameUrl, async (tex) => {
                        tex.colorSpace = THREE.SRGBColorSpace;
                        tex.wrapS = tex.wrapT = THREE.ClampToEdgeWrapping;
                        loadedFrameTexture = tex;
                        mats.frame.map = loadedFrameTexture;
                        mats.frame.needsUpdate = true;

                        await loadMainImage();
                        resolve();
                    }, undefined, async () => {
                        await loadMainImage();
                        resolve();
                    });
                } else {
                    loadMainImage().then(resolve);
                }
            });
        }

        function simulateProgress(targetPct, currentPct, elements) {
            const { fill, text } = elements;
            let localPct = currentPct;

            // 1. Move quickly to the immediate milestone
            localPct = targetPct;
            if (fill) fill.style.width = localPct + '%';
            if (text) text.innerText = Math.round(localPct) + '%';

            // 2. Start a "creep" interval to simulate activity during heavy processing
            const creepInterval = setInterval(() => {
                if (localPct < targetPct + 15 && localPct < 99) {
                    localPct += 0.5; // Slow increment
                    if (fill) fill.style.width = localPct + '%';
                    if (text) text.innerText = Math.round(localPct) + '%';
                }
            }, 100);

            return {
                stop: () => {
                    clearInterval(creepInterval);
                    return localPct;
                }
            };
        }

        function loadMainImage() {
            return new Promise((resolve) => {
                // Safety: if IMAGE_URL is undefined here, stop immediately but resolve
                if (!IMAGE_URL) {
                    console.error("loadMainImage called with undefined IMAGE_URL");
                    resolve();
                    return;
                }

                const img = new Image();
                img.crossOrigin = "Anonymous";

                img.onerror = () => {
                    console.error("404 Error: Image not found at", IMAGE_URL);
                    // We resolve so the UI doesn't freeze
                    resolve();
                };

                img.onload = function () {
                    // 1. Keep the high-res image in 'rawImage' for printing/cropping logic
                    rawImage = img;

                    // 2. CREATE A LOW-RES PROXY FOR 3D (Max 1024px)
                    const canvas = document.createElement('canvas');
                    const maxDim = 1024; // Sweet spot for mobile and desktop speed
                    let width = img.width;
                    let height = img.height;

                    if (width > height) {
                        if (width > maxDim) {
                            height *= maxDim / width;
                            width = maxDim;
                        }
                    } else {
                        if (height > maxDim) {
                            width *= maxDim / height;
                            height = maxDim;
                        }
                    }

                    canvas.width = width;
                    canvas.height = height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, width, height);

                    // 3. Use this smaller canvas as the texture
                    loadedImageTexture = new THREE.CanvasTexture(canvas);
                    loadedImageTexture.colorSpace = THREE.SRGBColorSpace;

                    mats.image = new THREE.MeshStandardMaterial({
                        map: loadedImageTexture,
                        color: 0xffffff,
                        roughness: 0.6,
                        metalness: 0.0,
                        // The image now acts as its own light source
                        emissiveMap: loadedImageTexture,
                        emissive: new THREE.Color(0xffffff),
                        emissiveIntensity: hasLED ? 30 : 0.0
                    });
                    mats.image.needsUpdate = true;
                    loadedImageTexture.generateMipmaps = false; 
                    loadedImageTexture.minFilter = THREE.LinearFilter;
                    resolve();
                };

                img.src = IMAGE_URL;
                console.log("checking image change", IMAGE_URL)
            });
        }
        /**
         * Waits for croppedData.originalImage to be populated before starting the build.
         */
        function proceedWhenImageReady(timeoutMs = 20000) {
            const startTime = Date.now();
            const statusMsg = document.getElementById('loader-status-msg');
            const loader = document.getElementById('ar-loader-overlay');
            loaderDiv.querySelector('#progress-text').innerText = '0%'
            if (statusMsg) statusMsg.innerText = "Initializing...";
            const checkInterval = setInterval(() => {
                // 1. Check if the image data is finally available
                console.log("here is the uload starting croppedData", croppedData)
                if (typeof croppedData !== 'undefined' && croppedData.originalImage) {
                    clearInterval(checkInterval);
                    if (statusMsg) statusMsg.innerText = "Image received! Starting build...";

                    IMAGE_URL = croppedData.originalImage;
                    selectedOptionData(); // Trigger the main async pipeline
                }

                // 2. Update message if it's taking a few seconds
                else {
                    const elapsed = Date.now() - startTime;
                    if (elapsed > 2000 && statusMsg) {
                        statusMsg.innerText = "Processing your image, please wait...";
                    }
                    if (elapsed > 5000 && statusMsg) {
                        statusMsg.innerText = "Finalizing crop data...";
                    }
                }

                // 3. Safety Timeout
                if (Date.now() - startTime > timeoutMs) {
                    clearInterval(checkInterval);
                    console.error("Timeout: Cropped image data never arrived.");
                    if (statusMsg) statusMsg.innerText = "Error: Image processing timed out.";
                    setTimeout(() => {
                        if (loader) loader.style.display = 'none';
                    }, 2000);
                }
            }, 100);
        }

        if (uploadOption) {
            uploadOption.addEventListener('change', function () {
                console.log("Upload initiated. Waiting for image data...");

                // Start the loader immediately so the user knows something is happening
                const loader = document.getElementById('ar-loader-overlay');
                if (loader) loader.style.display = 'flex';

                // Call our new waiting function
                proceedWhenImageReady(20000);
            });
        }

        var cropClicked = document.querySelector('#crop_button')
        if(cropClicked){
            cropClicked.addEventListener('click', async function(){
                if (!cropper) {
                    console.error("Cropper instance not found.");
                    return;
                }
                // 1. Get the crop coordinates (x, y, width, height)
                // 'true' ensures we get the data relative to the original image size
                let data = croppedData[currentSize.ratio] || cropper.getData();
                console.log("here is the data", data)
                // 2. Update the global croppedDataV2 variable used by buildModel
                // We keep 'originalImage' so the loader knows the image is ready
                croppedDataV2 = {
                    ...data,
                    originalImage: IMAGE_URL
                };
                // isManualCrop = true;
                console.log("New Crop Data Captured:", croppedDataV2);
                if (!isGenerateBtnClicked) {
                    await selectedOptionData();

                    // 4. Force model-viewer to notice the change
                    const viewer = document.querySelector('model-viewer');
                    if (viewer) {
                        viewer.dismissPoster(); // Forces a refresh of the internal render
                    }
                }
            })
        }

        // function applyCropToTexture(texture, cropData, originalImg) {
        //     console.log("texture is", texture)
        //     console.log("cropData is", cropData)
        //     console.log("originalImg is", originalImg.naturalWidth)
        //     if (!texture || !cropData || !originalImg) return;
        //     console.log("its eneter 547")
        //     // Get the full resolution of the original uploaded image
        //     const imgW = originalImg.naturalWidth;
        //     const imgH = originalImg.naturalHeight;

        //     // 1. Calculate Repeat (Zoom level)
        //     const repeatX = cropData.width / imgW;
        //     const repeatY = cropData.height / imgH;

        //     // 2. Calculate Offset (Position)
        //     const offsetX = cropData.x / imgW;
        //     // UV 0,0 is bottom-left; Cropper 0,0 is top-left, so we flip the Y axis
        //     const offsetY = 1.0 - (cropData.y + cropData.height) / imgH;

        //     // 3. Apply to texture
        //     texture.repeat.set(repeatX, repeatY);
        //     texture.offset.set(offsetX, offsetY);

        //     // 4. Ensure texture does not "tile" (pattern repeat)
        //     texture.wrapS = texture.wrapT = THREE.ClampToEdgeWrapping;
        //     texture.matrixAutoUpdate = true;
        //     texture.updateMatrix();
        //     texture.needsUpdate = true;
        //     console.log("applyCropToTexture is end")
        // }

        function applyCropToTexture(texture, cropData, originalImg, paperW, paperH, borderSize) {
            // 1. Safety check for all required inputs
            // if (!texture || !cropData || !originalImg || !paperW || !paperH) {
            //     console.error("applyCropToTexture: Missing required parameters", { texture, cropData, originalImg, paperW, paperH });
            //     return;
            // }
            console.log("here is the texture", texture)
            console.log("here is the cropData", cropData)
            console.log("here is the originalImg", originalImg)
            console.log("here is the paperW", paperW)
            console.log("here is the paperH", paperH)
            console.log("here is the borderSize", borderSize)

            if(isPrintOnly){
                console.log("this is only for print")

                const canvas = texture.image; // Access the canvas from the CanvasTexture
                const ctx = canvas.getContext('2d');

                // 2. Define resolution for the 3D preview
                // We use a 1024px maximum to keep the GLB file size small and fast
                const maxDim = 1024;
                const scale = maxDim / Math.max(paperW, paperH);
                canvas.width = paperW * scale;
                canvas.height = paperH * scale;

                // 3. Draw the White Background (The Border)
                ctx.fillStyle = '#ffffff';
                ctx.fillRect(0, 0, canvas.width, canvas.height);

                // 4. Calculate the "Photo Area" within the paper
                // The photo sits inside the border
                const drawX = borderSize * scale;
                const drawY = borderSize * scale;
                const drawW = (paperW - (borderSize * 2)) * scale;
                const drawH = (paperH - (borderSize * 2)) * scale;

                // 5. Draw the Cropped Image
                // Syntax: drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight)
                ctx.drawImage(
                    originalImg,
                    cropData.x, cropData.y, cropData.width, cropData.height, // The part of the high-res file to take
                    drawX, drawY, drawW, drawH                             // Where to put it on the paper
                );

                // 6. Reset Texture Matrix
                // Since the layout is now physically drawn on the canvas, we reset repeat/offset
                texture.repeat.set(1, 1);
                texture.offset.set(0, 0);
                texture.wrapS = texture.wrapT = THREE.ClampToEdgeWrapping;
                
                // 7. Force GPU Update
                texture.needsUpdate = true;
                console.log("Texture baked: Crop and Border are now physical pixels on the canvas.");
            }else{
                console.log("this is framed and others")
                // Get the full resolution of the original uploaded image
                const imgW = originalImg.naturalWidth;
                const imgH = originalImg.naturalHeight;

                // 1. Calculate Repeat (Zoom level)
                const repeatX = cropData.width / imgW;
                const repeatY = cropData.height / imgH;

                // 2. Calculate Offset (Position)
                const offsetX = cropData.x / imgW;
                // UV 0,0 is bottom-left; Cropper 0,0 is top-left, so we flip the Y axis
                const offsetY = 1.0 - (cropData.y + cropData.height) / imgH;

                // 3. Apply to texture
                texture.repeat.set(repeatX, repeatY);
                texture.offset.set(offsetX, offsetY);

                // 4. Ensure texture does not "tile" (pattern repeat)
                texture.wrapS = texture.wrapT = THREE.ClampToEdgeWrapping;
                texture.matrixAutoUpdate = true;
                texture.updateMatrix();
                texture.needsUpdate = true;
                console.log("applyCropToTexture is end")
            }
            

            
        }

        function injectGenerateButton() {
            const widthInput = document.querySelector('input[action="custom-size-width"]');
            const heightInput = document.querySelector('input[action="custom-size-height"]');

            // 1. If inputs aren't on the DOM yet, just exit
            if (!widthInput || !heightInput) return;

            // 2. SAFETY CHECK: If button already exists, do not add it again
            if (document.getElementById('generate_custom_size')) return;

            // 3. Create the button
            const genBtn = document.createElement('button');
            genBtn.type = 'button';
            genBtn.id = 'generate_custom_size';
            genBtn.className = 'button';
            genBtn.innerText = 'Generate';

            // Style as requested
            Object.assign(genBtn.style, {
                fontSize: '12px',
                padding: '7px 15px',
                backgroundColor: '#000',
                color: '#fff',
                borderRadius: '5px',
                cursor: 'pointer',
                border: 'none',
                marginLeft: '10px',
                display: 'inline-block',
                width: '30%'
            });

            genBtn.addEventListener('click', handleGenerateClick);

            // Inject beside the height input
            heightInput.parentNode.after(genBtn);
            console.log("Generate button successfully injected once.");
        }

        function handleGenerateClick() {
            isGenerateBtnClicked = true;
            const widthInput = document.querySelector('input[action="custom-size-width"]');
            const heightInput = document.querySelector('input[action="custom-size-height"]');

            const w = parseFloat(widthInput.value);
            const h = parseFloat(heightInput.value);

            // 1. Safety Validation
            if (isNaN(w) || w <= 0 || isNaN(h) || h <= 0) {
                alert("Please enter a valid Width and Height.");
                return;
            }

            // 2. Update Global State
            currentSize.width = w;
            currentSize.height = h;

            // Show the loader manually if your pipeline doesn't do it fast enough
            // const loader = document.getElementById('ar-loader-overlay');
            // if (loader) loader.style.display = 'flex';

            // 3. Visual Feedback
            const btn = document.getElementById('generate_custom_size');
            btn.innerText = "Generating...";
            btn.style.opacity = "0.6";
            btn.disabled = true;

            console.log(`Pipeline Triggered: Building ${w}x${h} frame.`);
            // cropClick()
            // 4. Run your main build pipeline
            selectedOptionData();
        }

        function handleCustomSizeActivation() {
            if (isCustomSizeActive) return;
            // 2. Capture the LAST known good size
            // We use currentConfig because it holds the active 3D dimensions
            const lastWidth = currentConfig.width;
            const lastHeight = currentConfig.height;

            // 3. Populate the custom input boxes with these values
            const wInput = document.querySelector('input[action="custom-size-width"]');
            const hInput = document.querySelector('input[action="custom-size-height"]');

            if (wInput && hInput) {
                wInput.value = lastWidth;
                hInput.value = lastHeight;
            }

            isCustomSizeActive = true;
            // 4. Update the global currentSize state so buildModel doesn't see NaN
            currentSize.width = lastWidth;
            currentSize.height = lastHeight;

            // 6. Ensure the Generate button is there
            injectGenerateButton();

            // 7. Refresh the pipeline
            selectedOptionData();
        }

        // Move this OUTSIDE of any if-statements and into your main init code
        function initCustomSizeListeners() {
            ['custom-size-width', 'custom-size-height'].forEach(action => {
                const el = document.querySelector(`input[action="${action}"]`);
                if (el) {
                    el.addEventListener('keydown', (e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            console.log("Enter key detected. Triggering Generate...");
                            handleGenerateClick();
                        }
                    });
                }
            });
        }

        // Call this once on page load
        initCustomSizeListeners();

        const toggle = document.getElementById('liveraf-toggleSwitch');
        // Updated Toggle Logic
        if(toggle){
            toggle?.addEventListener('change', function(e) {

                // 1. Toggle the visual 'active' class on labels
                labels.forEach(label => label.classList.toggle("liveraf-active"));
                
                // 2. Trigger the size filtering logic
                // window.updateSizeVisibility();

                // 3. Optional: if you have a specific 'setOrientation' function defined elsewhere
                if (typeof setOrientation === "function") {
                    setOrientation(this.checked ? 'portrait' : 'landscape');
                    console.log("here is the toggle before", currentSize)
                    setTimeout(function(){
                        e.preventDefault()
                        console.log("here is the toggle", currentSize)
                        console.log("here is the currentSize.width", toggle.checked)
                        if (currentSize.orientation == 'portrait') {
                            console.log("enter potrait")
                            currentConfig.width = Math.min(currentSize.width, currentSize.height);
                            currentConfig.height = Math.max(currentSize.width, currentSize.height);
                        } else if(currentSize.orientation == 'landscape') {
                            // Landscape: Force the wider dimension to Width
                            console.log("enter landscape")
                            currentConfig.width = Math.max(currentSize.width, currentSize.height);
                            currentConfig.height = Math.min(currentSize.width, currentSize.height);
                        }else{
                            currentConfig.width = currentSize.width;
                            currentConfig.height = currentSize.height;
                        }
                        selectedOptionData()
                    },510)
                }
            });
        }
        function selectedOptionData() {
            injectGenerateButton();
            hasFrame = false;
            isContourFrame = false;
            console.log("here is the currentSize.width", currentSize.width)
            console.log("here is the currentSize.height", currentSize.height)
            currentConfig.material = null;
            isPrintOnly = true;
            newConfig = {
                ...currentConfig,
                width: currentSize.width,
                height: currentSize.height,
                frame: currentSize.frameThickness,
                hasGlass: false
            };
            // We use these flags to determine what action to take AFTER the loop
            let targetFrameUrl = null;
            let targetFrameColor = null;
            const selectedElements = document.querySelectorAll(
                'all-variant input:checked, all-variant select'
            );
            selectedElements.forEach(el => {
                const source =
                    el.tagName === 'SELECT' ? el.options[el.selectedIndex] : el;
                if (!source) return;
                const optionValueId = source.getAttribute('data-option-value-id');
                if (!optionValueId) return;

                const action = source.getAttribute('action');
                const value = source.getAttribute('value');
                const optionName = source.getAttribute('option_name');
                selc_FrameWidth = source.getAttribute('frame-width')
                selc_FrameDepth = source.getAttribute('frame-depth')
                selc_FrameRabbetDepth = source.getAttribute('frame-rabbet-depth')
                selc_FrameRabbetWidth = source?.getAttribute('frame-rabbet-width')
                let getFrameProfId = source.getAttribute('profile-id')
                if(getFrameProfId && frameProfiles[getFrameProfId]){
                    let encodeProfilePath = frameProfiles[getFrameProfId]['profile_path']
                    var decodedProfilePath = atob(encodeProfilePath);
                    console.log("here is the decodedProfilePath", decodedProfilePath)
                    frameFrontTexture = frameProfiles[getFrameProfId].front_texture
                    frameSideTexture = frameProfiles[getFrameProfId].side_texture
                }

                if (action === 'custom-size-width' || action === 'custom-size-height') {
                    console.log("Input ignored by global listener. Waiting for 'Generate' click.");
                    return; // STOP: Do not run selectedOptionData()
                }
                if (value.toLowerCase() == 'custom size') {
                    handleCustomSizeActivation()
                }
                if (action === 'size' && value.toLowerCase() !== 'custom size') {
                    // If a standard size is picked, turn OFF custom mode
                    isCustomSizeActive = false;
                }
                if (action === 'frame') {
                    hasFrame = false;
                    newConfig.type = 'framed';
                    isPrintOnly = false;
                    newConfig.frameWidth = selc_FrameWidth || 1.0;
                    newConfig.frameDepth = selc_FrameDepth || 1.0;
                    newConfig.rabbetDepth = selc_FrameRabbetDepth || 0.8;
                    newConfig.rabbetWidth = selc_FrameRabbetWidth || 1.2;
                    // console.log("here is the newConfig.frame", newConfig.frame)
                    isContourFrame = true;
                    FRAME_PROFILE = decodedProfilePath;
                    // CHECK: Does this frame have a texture URL?
                    if (frameFrontTexture && frameFrontTexture !== '') {
                        targetFrameUrl = frameFrontTexture;
                    }
                    // CHECK: Is it a known solid color?
                    else if (value.toLowerCase().includes('white')) {
                        targetFrameColor = '#ffffff';
                    }
                    else if (value.toLowerCase().includes('black') && !frameFrontTexture) {
                        // Only set black color if there is NO texture url (some black woods have texture)
                        targetFrameColor = '#111111';
                    }
                    
                }
                // if (action === 'frame') {
                //     isContourFrame = false;
                //     newConfig.floater = false;
                //     newConfig.type = 'framed';
                //     // let depthEl = document.querySelector('#' + getId + '-description p#frameDepth')
                //     // let frameDepth = depthEl ? parseFloat(depthEl.innerText) : 1.0;
                //     // let rabbetDepthEle = document.querySelector('#' + getId + '-description p#rabbetDepth')
                //     // let rabbetDepth = rabbetDepthEle ? parseFloat(rabbetDepthEle.innerText) : 0.8;
                //     console.log("its notmal frame")
                //     newConfig.frameWidth = selc_FrameWidth || 1.0;
                //     newConfig.frameDepth = selc_FrameDepth || 1.0;
                //     newConfig.rabbetDepth = selc_FrameRabbetDepth || 0.8;
                //     hasFrame = true;
                //     // console.log("this is normal frame section")
                //     // CHECK: Does this frame have a texture URL?
                //     if (frameFrontTexture && frameFrontTexture !== '') {
                //         targetFrameUrl = frameFrontTexture;
                //     }
                //     // CHECK: Is it a known solid color?
                //     else if (value.toLowerCase().includes('white')) {
                //         targetFrameColor = '#ffffff';
                //     }
                //     else if (value.toLowerCase().includes('black') && !frameFrontTexture) {
                //         // Only set black color if there is NO texture url (some black woods have texture)
                //         targetFrameColor = '#111111';
                //     }
                // }
                else if (action === 'paper-print') {
                    newConfig.type = 'framed';
                    newConfig.floater = false;
                    newConfig.frameWidth = 0;
                    newConfig.mat1 = 0;
                    newConfig.mat2 = 0;
                    newConfig.hasGlass = false;
                    // Ensure the animation array is ready for the upcoming build
                    activeAnimations = [];
                }
                else if (optionName === 'Print Only Border') {
                    if(value.includes('No') ){
                        newConfig.hasBorder = false;
                        newConfig.printBorder = 0;
                    }else{
                        newConfig.hasBorder = true;
                        const borderString = value;
                        const match = borderString.match(/\d+(\.\d+)?/); // Finds the first sequence of digits
                        const numberOnly = match ? parseInt(match[0]) : 0;
                        newConfig.printBorder = numberOnly;
                    }
                }
                else if (action === '1st-mat-size') {
                    isPrintOnly = false;
                    newConfig.mat1 = parseFloat(currentSize.firstMatSize) || 0;
                }
                else if (action === '1st-mat-colour' || action === '1st-mat-style') {
                    isPrintOnly = false;
                    let matStyleValue = null;

                    // Find associated label and extract image src inside span tag
                    const sourceId = source.getAttribute('id');
                    let labelElem = null;
                    if (sourceId) {
                        try {
                            labelElem = document.querySelector(`label[for="${CSS.escape(sourceId)}"]`);
                        } catch (e) {
                            labelElem = document.querySelector(`label[for="${sourceId}"]`);
                        }
                        if (!labelElem) {
                            labelElem = Array.from(document.querySelectorAll('label')).find(l => l.getAttribute('for') === sourceId);
                        }
                    }
                    if (!labelElem) {
                        labelElem = (source.nextElementSibling && source.nextElementSibling.tagName === 'LABEL') 
                            ? source.nextElementSibling 
                            : source.closest('div, fieldset')?.querySelector('label');
                    }

                    if (labelElem) {
                        const imgElem = labelElem.querySelector('span img, img.swatchImage, img');
                        if (imgElem && imgElem.src) {
                            matStyleValue = imgElem.src;
                        }
                    }

                    if (!matStyleValue) {
                        matStyleValue = currentSize.firstMatColor || source.getAttribute('value') || value;
                    }

                    if (matStyleValue) {
                        updateMat1Color(matStyleValue);
                        currentConfig.mat1Color = matStyleValue;
                    }
                }
                else if (action === '2nd-mat-colour' || action === '2nd-mat-style') {
                    isPrintOnly = false;
                    let matStyleValue = null;

                    const sourceId = source.getAttribute('id');
                    let labelElem = null;
                    if (sourceId) {
                        try {
                            labelElem = document.querySelector(`label[for="${CSS.escape(sourceId)}"]`);
                        } catch (e) {
                            labelElem = document.querySelector(`label[for="${sourceId}"]`);
                        }
                        if (!labelElem) {
                            labelElem = Array.from(document.querySelectorAll('label')).find(l => l.getAttribute('for') === sourceId);
                        }
                    }
                    if (!labelElem) {
                        labelElem = (source.nextElementSibling && source.nextElementSibling.tagName === 'LABEL') 
                            ? source.nextElementSibling 
                            : source.closest('div, fieldset')?.querySelector('label');
                    }

                    if (labelElem) {
                        const imgElem = labelElem.querySelector('span img, img.swatchImage, img');
                        if (imgElem && imgElem.src) {
                            matStyleValue = imgElem.src;
                        }
                    }

                    if (!matStyleValue) {
                        matStyleValue = currentSize.secondMatColor || source.getAttribute('value') || value;
                    }

                    if (matStyleValue) {
                        updateMat2Color(matStyleValue);
                        currentConfig.mat2Color = matStyleValue;
                    }
                }
                else if (action === '2nd-mat-size') {
                    newConfig.mat2 = parseFloat(currentSize.secondMatSize) || 0;
                    isPrintOnly = false;
                }
                else if (['acrylic-spacers', 'acrylic-mount', 'acrylic-sandwich'].includes(action)) {
                    newConfig.type = 'acrylic'; newConfig.floater = false;
                    newConfig.material = 'acrylic';
                    newConfig.hasGlass = true;
                    isPrintOnly = false;
                }
                else if (action === 'metal-mount') {
                    newConfig.type = 'metal'; newConfig.floater = false;
                    newConfig.material = 'metal';
                    isPrintOnly = false;
                }
                else if (optionName === 'HD Metal Surface') {
                    newConfig.metalFinish = value; newConfig.floater = false;
                }
                else if (['canvas-classic-wrap', 'canvas-mirror', 'canvas-colour', 'canvas-blur'].includes(action)) {
                    newConfig.type = 'canvas';
                    newConfig.floater = false;
                    isPrintOnly = false;
                    if (action === 'canvas-classic-wrap') newConfig.wrap = 'normal';
                    if (action === 'canvas-mirror') newConfig.wrap = 'mirror';
                    if (action === 'canvas-blur') newConfig.wrap = 'blur';
                    if (action === 'canvas-colour') newConfig.wrap = 'color_' + source.getAttribute('value');
                    // console.log("here is the color value", source.getAttribute('value'))
                }
                else if(optionName === 'Canvas Thickness'){
                    const wrapString = value;
                    const wrapMatch = wrapString.match(/\d+(\.\d+)?/); 
                    const canvasWrapThick = wrapMatch ? parseFloat(wrapMatch[0]) : 0;
                    newConfig.canvasWrapThick = Number(canvasWrapThick);
                }
                else if (action === 'floater-frame') {
                    newConfig.type = 'floaterFrame';
                    newConfig.floater = true;
                    isPrintOnly = false;
                    // CHECK: Does this frame have a texture URL?
                    if (frameFrontTexture && frameFrontTexture !== '') {
                        targetFrameUrl = frameFrontTexture;
                    }
                    // CHECK: Is it a known solid color?
                    else if (value.toLowerCase().includes('white')) {
                        targetFrameColor = '#ffffff';
                    }
                    else if (value.toLowerCase().includes('black') && !frameFrontTexture) {
                        // Only set black color if there is NO texture url (some black woods have texture)
                        targetFrameColor = '#111111';
                    }
                }
                else if (source.getAttribute('option_name') === 'Glass') {
                    if (value !== 'None') {
                        newConfig.hasGlass = true;
                    } else {
                        newConfig.hasGlass = false;
                    }
                }
                else if (optionName == 'LED Lighting') {
                    if (value == 'LED Light') {
                        hasLED = true;
                    } else {
                        hasLED = false;
                    }
                }
                else if (optionName == 'Backs') {
                    if(value == 'Float Mount'){
                        newConfig.backMountType = 'Float Mount';
                    }else if(value.includes('Tape')){
                        newConfig.backMountType = 'Tape';
                    }else if(value.includes('Aluminum')){
                        newConfig.backMountType = 'Aluminum';
                        var getAluId = source.getAttribute('id')
                        AluMountProfile = document.querySelector('#' + getAluId + '-description').innerText
                    }
                    
                }

            });
            // At the end of selectedOptionData
            currentConfig = newConfig;
            ; (async () => {
                // 1. FINAL SAFETY CHECK
                console.log("here we have the IMAGE_URL", IMAGE_URL)
                if (!IMAGE_URL || IMAGE_URL === "undefined") {
                    console.warn("Pipeline blocked: No valid IMAGE_URL.");
                    return;
                }
                console.log("is it run when image changed")
                const loader = document.getElementById('ar-loader-overlay');
                const statusMsg = document.getElementById('loader-status-msg'); // Targeted status element
                const elements = {
                    fill: document.getElementById('progress-fill'),
                    text: document.getElementById('progress-text')
                };

                if (loader) loader.style.display = 'flex';
                let currentPct = 0;
                let progressTracker;

                try {
                    // --- Phase 0: Customer Image / Resources ---
                    if (statusMsg) statusMsg.innerText = "Loading image and resources...";
                    progressTracker = simulateProgress(10, currentPct, elements);
                    await loadResources();
                    currentPct = progressTracker.stop();

                    // --- Phase 1: Textures ---
                    if (statusMsg) statusMsg.innerText = "Applying frame textures...";
                    progressTracker = simulateProgress(30, currentPct, elements);
                    if (targetFrameUrl) {
                        await updateFrameTexture(targetFrameUrl);
                    } else if (targetFrameColor) {
                        setFrameColor(targetFrameColor);
                    }
                    currentPct = progressTracker.stop();

                    // --- Phase 2: Geometry ---
                    if (statusMsg) statusMsg.innerText = "Building 3D geometry...";
                    progressTracker = simulateProgress(60, currentPct, elements);
                    await buildModel();
                    currentPct = progressTracker.stop();

                    // --- Phase 3: Export & View ---
                    if (statusMsg) statusMsg.innerText = "Preparing 3D preview...";
                    progressTracker = simulateProgress(85, currentPct, elements);
                    await updateModelViewer();
                    currentPct = progressTracker.stop();

                    // --- Phase 4: Finalize ---
                    if (statusMsg) statusMsg.innerText = "Complete!";
                    simulateProgress(100, currentPct, elements);

                } catch (error) {
                    console.error("Upload process failed:", error);
                    if (statusMsg) statusMsg.innerText = "Error building model.";
                } finally {
                    // Delay slightly so the user sees "Complete!" or "100%"
                    setTimeout(() => {
                        if (loader) {
                            loader.style.display = 'none';
                            // Reset for next time
                            if (elements.fill) elements.fill.style.width = '0%';
                            if (statusMsg) statusMsg.innerText = "";
                        }
                    }, 1000);
                }
            })();
        }

        function updateFrameTexture(url) {
            console.log("the url is", url)
            return new Promise((resolve, reject) => {
                console.log("the url is", url)
                if (loadedFrameTexture && loadedFrameTexture.image && loadedFrameTexture.image.src === url) {
                    resolve(loadedFrameTexture);
                    return;
                }

                textureLoader.load(url, (tex) => {
                    console.log("the url is", url)
                    tex.colorSpace = THREE.SRGBColorSpace;
                    tex.wrapS = tex.wrapT = THREE.ClampToEdgeWrapping;
                    tex.repeat.set(1, 1);

                    loadedFrameTexture = tex;
                    mats.frame.map = loadedFrameTexture;
                    console.log("the loadedFrameTexture", loadedFrameTexture)
                    mats.frame.color.setHex(0xffffff);
                    mats.frame.needsUpdate = true;

                    resolve(tex);
                }, undefined, (err) => reject(err));
            });
        }
        function setFrameColor(hexColor) {
            // Remove texture, set solid color
            mats.frame.map = null;
            loadedFrameTexture = null; // Clear global tracker
            mats.frame.color.set(hexColor);
            mats.frame.needsUpdate = true;
        }

        // Update Outer Mat (Mat 1)
        window.updateMat1Color = function (colorValue) {
            if (!mats.mat1Material) return;

            // Check if colorValue is an image URL (for swatches/textures)
            if (typeof colorValue === 'string' && (
                colorValue.startsWith('http://') || 
                colorValue.startsWith('https://') || 
                colorValue.startsWith('data:image/') || 
                /\.(jpg|jpeg|png|webp|gif)(\?.*)?$/i.test(colorValue)
            )) {
                new THREE.TextureLoader().load(colorValue, (texture) => {
                    texture.wrapS = THREE.RepeatWrapping;
                    texture.wrapT = THREE.RepeatWrapping;
                    mats.mat1Material.map = texture;
                    mats.mat1Material.color.set('#ffffff');
                    mats.mat1Material.needsUpdate = true;
                    generateGLB();
                });
                return;
            }

            if (mats.mat1Material.map) {
                mats.mat1Material.map.dispose();
                mats.mat1Material.map = null;
            }

            if (typeof colorValue === 'object' && colorValue.r !== undefined) {
                mats.mat1Material.color.setRGB(colorValue.r, colorValue.g, colorValue.b);
            } else if (colorValue) {
                mats.mat1Material.color.set(colorValue);
            }
            mats.mat1Material.needsUpdate = true;

            generateGLB();
        }

        // Update Inner Mat (Mat 2)
        window.updateMat2Color = function (colorValue) {
            if (!mats.mat2Material) return;

            // Check if colorValue is an image URL (for swatches/textures)
            if (typeof colorValue === 'string' && (
                colorValue.startsWith('http://') || 
                colorValue.startsWith('https://') || 
                colorValue.startsWith('data:image/') || 
                /\.(jpg|jpeg|png|webp|gif)(\?.*)?$/i.test(colorValue)
            )) {
                new THREE.TextureLoader().load(colorValue, (texture) => {
                    texture.wrapS = THREE.RepeatWrapping;
                    texture.wrapT = THREE.RepeatWrapping;
                    mats.mat2Material.map = texture;
                    mats.mat2Material.color.set('#ffffff');
                    mats.mat2Material.needsUpdate = true;
                    generateGLB();
                });
                return;
            }

            if (mats.mat2Material.map) {
                mats.mat2Material.map.dispose();
                mats.mat2Material.map = null;
            }

            if (typeof colorValue === 'object' && colorValue.r !== undefined) {
                mats.mat2Material.color.setRGB(colorValue.r, colorValue.g, colorValue.b);
            } else if (colorValue) {
                mats.mat2Material.color.set(colorValue);
            }
            mats.mat2Material.needsUpdate = true;

            generateGLB();
        }

        // --- BUILDER LOGIC ---
        async function buildModel() {
            if (!loadedImageTexture) return;
            // --- CLEANUP ---
            while (exportGroup.children.length > 0) {
                const obj = exportGroup.children[0];
                obj.traverse((child) => {
                    if (child.isMesh) {
                        if (child.geometry) child.geometry.dispose();
                        if (child.material) {
                            const materials = Array.isArray(child.material) ? child.material : [child.material];
                            materials.forEach(mat => {
                                if (mat.map) mat.map.dispose();
                                mat.dispose();
                            });
                        }
                    }
                });
                exportGroup.remove(obj);
            }

            // CRITICAL: Reset the animations array so old clips don't persist
            activeAnimations = [];

            // Move the crop logic to the TOP of buildModel
            if(cropper){
                // 2. Update the global croppedDataV2 variable used by buildModel
                // We keep 'originalImage' so the loader knows the image is ready
                // if (!isManualCrop) {
                    
                    var onloadCropData = croppedData[currentSize.ratio] || cropper.getData();
                    croppedDataV2 = {
                        ...onloadCropData,
                        originalImage: IMAGE_URL
                    };
                    console.log("when Size cropper.getData()", cropper.getData())
                    console.log("when Size croppedDataV2", croppedDataV2)
                    console.log("Size/Orientation change detected. Fetching new crop...", croppedData[currentSize.ratio]);
                // } else {
                //     console.log("Manual crop detected. Using captured coordinates:", croppedDataV2);
                // }
                
            }
            console.log("here is the isPrintOnly", isPrintOnly)
            console.log("here is the croppedDataV2", croppedDataV2)
            if (!isPrintOnly && typeof croppedDataV2 !== 'undefined' && croppedDataV2.x !== undefined) {
                if (mats.image) mats.image.color.set(0xffffff); // Remove green tint
                applyCropToTexture(loadedImageTexture, croppedDataV2, rawImage, 0, 0, 0);
                loadedImageTexture.updateMatrix();
                loadedImageTexture.needsUpdate = true;
            }

            const factor = getUnitFactor(currentConfig.unit);
            const dims = {
                w : currentConfig.width * factor,
                h : currentConfig.height * factor,
                frame : currentConfig.frameWidth * factor
            }
            
            let printDepth = 0;
            switch (currentConfig.type) {
                // case 'framed': printDepth = await buildFramedPrint(); break;
                case 'framed': 
                    if (currentConfig.material === 'metal') {
                        const factor = getUnitFactor(currentConfig.unit);
                        const fDepth = currentConfig.frameDepth * factor;
                        const fRabbet = currentConfig.rabbetDepth * factor;
                        console.log("Target Metal fDepth:", fDepth);
                        console.log("Target Metal fRabbet:", fRabbet);
                        // The "shelf" relative to a frame centered at Z=0:
                        // (Half the depth moves to the front face, then back in by the rabbet)
                        const metalShelfZ = -(fDepth / 2) + fRabbet;
                        
                        console.log("Target Metal Position (Z):", metalShelfZ);
                        // 1. Build Plate first at the specific shelf position
                        printDepth = await buildMetalPrint(metalShelfZ);
                        dims.depth = printDepth;
                        if (dims.frame > 0 && loadedFrameTexture) {
                            if (isContourFrame) {
                                await buildContourFrame(dims);
                            } 
                        }
                    } else {
                        printDepth = await buildFramedPrint(); // Default to wrapped canvas
                    }
                break;
                case 'canvas': printDepth = buildCanvasPrint(); break;
                case 'floaterFrame': 
                    if (currentConfig.material === 'metal') {
                        printDepth = await buildMetalPrint(); // Builds the flat metal plate
                    }else if (currentConfig.material === 'acrylic') {
                        printDepth = await buildAcrylicPrint(); // Builds the flat metal plate
                    } else {
                        printDepth = await buildCanvasPrint(); // Default to wrapped canvas
                    }
                break;
                case 'acrylic': printDepth = await buildAcrylicPrint(); break;
                case 'metal': printDepth = await buildMetalPrint(0); break;
                default: printDepth = await buildFramedPrint(); break;
            }
            console.log("here is the cropped Data", croppedDataV2)
            

            if (currentConfig.type !== 'framed' && currentConfig.floater) {
                let factor = getUnitFactor(currentConfig.unit);
                const w = currentConfig.width * factor;
                const h = currentConfig.height * factor;
                addFloaterFrame(w, h, printDepth);
            }

            exportGroup.children.forEach(child => {
                console.log("Object Name:", child.name, "Z-Pos:", child.position.z);
            });

            // REMOVE THIS LINE:
            // await updateModelViewer(); 
        }

        // --- GLTF EXPORTER ---
        function generateGLB() {
            // UI Update
            progressFill.style.width = '0%';
            progressText.innerText = '0%';
            loaderDiv.style.display = 'flex';

            let percent = 0;
            const interval = setInterval(() => {
                percent += Math.random() * 5;
                if (percent > 95) percent = 95;
                progressFill.style.width = percent + '%';
                progressText.innerText = Math.round(percent) + '%';
            }, 50);

            setTimeout(() => {
                exporter.parse(exportGroup, (result) => {

                    clearInterval(interval);
                    progressFill.style.width = '100%';
                    progressText.innerText = '100%';

                    setTimeout(() => {
                        if (result instanceof ArrayBuffer) {
                            const blob = new Blob([result], { type: 'model/gltf-binary' });
                            const url = URL.createObjectURL(blob);
                            modelViewer.src = url;
                            loaderDiv.style.display = 'none';
                        }
                    }, 100);

                }, { binary: true });
            }, 50);
        }

        // --- ANIMATION LOOP (FIXED) ---
        function animate() {
            requestAnimationFrame(animate);
            const delta = clock.getDelta(); // Need a clock
            // Only update if mixer exists
            if (mixer) {
                mixer.update(delta);
            }
            // *** FIX 2: PREVENT CRASH ON 0 SIZE ***
            const width = renderer.domElement.width;
            const height = renderer.domElement.height;

            if (width === 0 || height === 0 || renderer.domElement.style.display === 'none') {
                return; // Stop rendering if hidden or zero size
            }

            renderer.render(scene, camera);
        }

        // --- WINDOW RESIZE (FIXED) ---
        window.addEventListener('resize', onWindowResize, false);
        function onWindowResize() {
            let canvasWidth = spatial3D.clientWidth;
            let canvasHeight = spatial3D.clientHeight;

            if (canvasWidth === 0 || canvasHeight === 0) {
                canvasWidth = 800; canvasHeight = 600; // Fallback
            }

            camera.aspect = canvasWidth / canvasHeight;
            camera.updateProjectionMatrix();
            renderer.setSize(canvasWidth, canvasHeight);
        }

        function resetExportGroup() {
            // 1. Remove the backstand if it exists
            const oldStand = exportGroup.getObjectByName("easel_backstand");
            if (oldStand) exportGroup.remove(oldStand);

            // 2. Clear all rotations
            exportGroup.rotation.set(0, 0, 0);

            // 3. Reset position (Builder functions will set their own Y later)
            exportGroup.position.set(0, 0, 0);

            // console.log("Scene reset: Ready for new build.");
        }

        function addFloaterFrame(printW, printH, printD) {
            if (!printD || isNaN(printD)) {
                console.error("Floater Frame Error: Invalid Print Depth");
                return;
            }

            let factor = getUnitFactor(currentConfig.unit);
            const gap = 0.005; // 5mm visual float gap
            const frameFace = 0.008; // 8mm face width

            // NEW: Rabbet Depth is the "shelf" height inside the frame
            // Usually, the canvas sits 5mm-10mm deep inside the frame
            const rabbetDepth = currentConfig.rabbetDepth ? currentConfig.rabbetDepth * factor : 0.01;
            const frameDepth = printD + rabbetDepth; // Total frame thickness

            // 1. SHADOW BOX / INNER BACKING
            // This creates the black "void" seen in the gap
            const backingW = printW + (gap * 2);
            const backingH = printH + (gap * 2);
            const backing = new THREE.Mesh(new THREE.BoxGeometry(backingW, backingH, 0.001), mats.shadowGap);
            // Positioned exactly at the back of the print
            backing.position.z = -printD / 2;
            exportGroup.add(backing);

            // 2. THE FRAME BARS (L-Profile Logic)
            const totalInnerW = printW + (gap * 2);
            const totalInnerH = printH + (gap * 2);

            // Z-Position: Align the frame so the canvas sits on the rabbet shelf
            const frameZ = (frameDepth / 2) - (printD / 2) - rabbetDepth;

            // --- TEXTURE TILING FIX ---
            // This prevents the stretching seen in your gold ornate texture
            // const patternWidth = 0.1; // The ornate pattern repeats every 10cm
            // const repeatW = (totalInnerW + (frameFace * 2)) / patternWidth;
            // const repeatH = (totalInnerH + (frameFace * 2)) / patternWidth;

            // Create unique materials for sides to handle different tiling lengths
            // const horizontalMat = mats.frame.clone();
            // horizontalMat.map = mats.frame.map.clone();
            // horizontalMat.map.wrapS = THREE.RepeatWrapping;
            // horizontalMat.map.repeat.set(repeatW, 1); // Tile along the length

            // const verticalMat = mats.frame.clone();
            // verticalMat.map = mats.frame.map.clone();
            // verticalMat.map.wrapS = THREE.RepeatWrapping;
            // verticalMat.map.repeat.set(repeatH, 1); // Tile along the length

            // Generate Mitered Bars
            const top = new THREE.Mesh(createMiteredBar(totalInnerW, frameFace, frameDepth), mats.frame);
            top.position.set(0, totalInnerH / 2, frameZ);
            exportGroup.add(top);

            const bot = top.clone(); bot.rotation.z = Math.PI;
            bot.position.set(0, -totalInnerH / 2, frameZ);
            exportGroup.add(bot);

            const right = new THREE.Mesh(createMiteredBar(totalInnerH, frameFace, frameDepth), mats.frame);
            right.rotation.z = -Math.PI / 2;
            right.position.set(totalInnerW / 2, 0, frameZ);
            exportGroup.add(right);

            const left = right.clone(); left.rotation.z = Math.PI / 2;
            left.position.set(-totalInnerW / 2, 0, frameZ);
            exportGroup.add(left);
        }

        function createContourBar(innerLength, svgPathData, targetWidth, targetDepth) {
            console.log("svgPathData is", svgPathData)
            // 1. Parse SVG
            const svgMarkup = `<svg xmlns="http://www.w3.org/2000/svg"><path d="${svgPathData}" /></svg>`;
            const loader = new THREE.SVGLoader();
            const svgData = loader.parse(svgMarkup);

            if (!svgData.paths || svgData.paths.length === 0) {
                console.error("Invalid Path");
                // Fallback: Use targetDepth if provided, else default to 0.02
                return new THREE.BoxGeometry(innerLength, targetWidth, targetDepth || 0.02);
            }

            const shape = svgData.paths[0].toShapes(true)[0];

            // 2. Extrude
            const geometry = new THREE.ExtrudeGeometry(shape, {
                steps: 1, depth: innerLength, bevelEnabled: false, curveSegments: 24
            });

            // 3. Independent Scaling (Width vs Depth)
            geometry.computeBoundingBox();
            const minX_Pre = geometry.boundingBox.min.x;
            const maxX_Pre = geometry.boundingBox.max.x;
            const minY_Pre = geometry.boundingBox.min.y;
            const maxY_Pre = geometry.boundingBox.max.y;

            const originalWidth = maxX_Pre - minX_Pre;
            const originalHeight = maxY_Pre - minY_Pre; // This corresponds to Depth (Y)

            // Calculate Scale Factors
            const scaleX = targetWidth / originalWidth;
            const scaleY = targetDepth / originalHeight;

            // Apply Scaling
            // -scaleX: Flips orientation (Left/Right) and scales Width
            // scaleY: Scales Depth (Thickness)
            // 1: Z-Axis (Length) is handled by Extrude depth, so we scale by 1 here
            geometry.scale(-scaleX, scaleY, 1);

            // 4. Center X (Re-align inner edge to 0)
            // geometry.computeBoundingBox();
            // console.log("here is the currentConfig.type 1214", currentConfig.type)
            // if(currentConfig.material == 'metal'){
            //     const finalMaxY = geometry.boundingBox.max.y; // The "top/front" face of the profile
            //     const finalMinX = geometry.boundingBox.min.x; 
            //     geometry.translate(-finalMinX, -finalMaxY, 0);
            // }else{
            //     const newMinX = geometry.boundingBox.min.x;
            //     const newMinY = geometry.boundingBox.min.y; // This is the back surface
            //     geometry.translate(-newMinX, -newMinY - (targetDepth / 2), 0);
            // }
            geometry.computeBoundingBox();
            const newMinX = geometry.boundingBox.min.x;
            const newMinY = geometry.boundingBox.min.y;
            const newMaxY = geometry.boundingBox.max.y;
            const profileActualDepth = newMaxY - newMinY;
            geometry.translate(-newMinX, -(newMinY + profileActualDepth / 2), 0);

            // 5. Miter Shear & UVs
            geometry.computeBoundingBox();
            const scaledMinX = geometry.boundingBox.min.x;
            const profileWidth = geometry.boundingBox.max.x - scaledMinX;

            const pos = geometry.attributes.position;
            const uv = geometry.attributes.uv;
            const norm = geometry.attributes.normal;
            const grainScale = 0.3; 

            // --- A. SHEAR & UV MAPPING ---
            for (let i = 0; i < pos.count; i++) {
                const x = pos.getX(i);
                const y = pos.getY(i);
                const originalZ = pos.getZ(i);

                let z = originalZ;
                const shift = x - scaledMinX;

                // 1. Shear logic (Miter)
                if (z <= 0.001) z -= shift;
                else if (z >= innerLength - 0.001) z += shift;
                pos.setZ(i, z);

                // 2. Face-Aware UV Mapping
                const ny = norm.getY(i);
                const nz = norm.getZ(i);

                let u, v;

                // Check if we are on the Front face or the Side/Depth faces
                if (Math.abs(ny) > 0.5 && Math.abs(nz) < 0.5) {
                    // FRONT FACE: u is across profile, v is along length
                    u = shift / profileWidth;
                    v = z / grainScale; // Tile along length to prevent blur
                } else {
                    // SIDE & DEPTH FACES: u is across the thickness, v is along length
                    // This ensures the side grain follows the wood length perfectly
                    u = (y + targetDepth / 2) / targetDepth; 
                    v = z / grainScale; 
                }

                uv.setXY(i, u, v);
            }

            geometry.attributes.position.needsUpdate = true;
            geometry.attributes.uv.needsUpdate = true;
            geometry.computeVertexNormals();

            // --- B. FACE SORTING (Separate Wood Front vs Plain Sides) ---

            // Generate Index if missing
            if (!geometry.index) {
                const indices = [];
                for (let i = 0; i < pos.count; i++) indices.push(i);
                const indexArray = (pos.count > 65535) ? new Uint32Array(indices) : new Uint16Array(indices);
                geometry.setIndex(new THREE.BufferAttribute(indexArray, 1));
            }

            const indexAttribute = geometry.index;
            const indices = indexAttribute.array;

            const plainIndices = [];
            const woodIndices = [];

            for (let i = 0; i < indices.length; i += 3) {
                const a = indices[i];
                const b = indices[i + 1];
                const c = indices[i + 2];

                // Check Normal Orientation
                const ny = (norm.getY(a) + norm.getY(b) + norm.getY(c)) / 3;
                const nz = (norm.getZ(a) + norm.getZ(b) + norm.getZ(c)) / 3;

                // Front Face = Points Up (+Y)
                const isFrontFace = (ny > 0.5) && (Math.abs(nz) < 0.5);

                if (isFrontFace) {
                    woodIndices.push(a, b, c);
                } else {
                    plainIndices.push(a, b, c);
                }
            }

            // Rebuild Groups
            const newIndices = new (indices.constructor === Uint32Array ? Uint32Array : Uint16Array)([...plainIndices, ...woodIndices]);
            geometry.setIndex(new THREE.BufferAttribute(newIndices, 1));

            geometry.clearGroups();
            geometry.addGroup(0, plainIndices.length, 0); // Material 0: Plain
            geometry.addGroup(plainIndices.length, woodIndices.length, 1); // Material 1: Wood

            // 6. Center Z
            geometry.translate(0, 0, -innerLength / 2);
            return geometry;
        }

        function createRollingPrint(width, height, texture, borderSize) {
            const segmentCount = 80;
            const segmentHeight = height / segmentCount;
            unrollDuration = 4.0; // Total unroll time in seconds
            // console.log("createRollingPrint texture is", texture)
            // --- 1. Geometry (Setup for Floor Unroll) ---
            const geometry = new THREE.PlaneGeometry(width, height, 1, segmentCount);

            // Shift geometry so the "Top" edge is at (0,0,0) - the Anchor.
            geometry.translate(0, -height / 2, 0);

            // --- 2. Bones & Spiral Math ---
            const bones = [];
            let prevBone = new THREE.Bone();
            bones.push(prevBone);
            prevBone.position.y = 0; // Root anchor

            for (let i = 0; i < segmentCount; i++) {
                const bone = new THREE.Bone();
                bone.position.y = -segmentHeight; // Extend chain downwards

                // --- Spiral Logic ---
                const baseAngle = (6 * Math.PI) / segmentCount;
                const spiralFactor = 1 + (i / segmentCount) * 0.5;

                bone.userData.curlAngle = baseAngle * spiralFactor;

                prevBone.add(bone);
                bones.push(bone);
                prevBone = bone;
            }

            const skeleton = new THREE.Skeleton(bones);

            // --- 3. Skinning ---
            const position = geometry.attributes.position;
            const skinIndices = [];
            const skinWeights = [];

            for (let i = 0; i < position.count; i++) {
                const y = position.getY(i);
                let boneIndex = Math.floor(Math.abs(y) / segmentHeight);
                if (boneIndex >= bones.length) boneIndex = bones.length - 1;

                skinIndices.push(boneIndex, 0, 0, 0);
                skinWeights.push(1, 0, 0, 0);
            }
            geometry.setAttribute('skinIndex', new THREE.Uint16BufferAttribute(skinIndices, 4));
            geometry.setAttribute('skinWeight', new THREE.Float32BufferAttribute(skinWeights, 4));

            // Configure texture settings for sharpness
            let localTexture = null;
            console.log("here is the printOnly croppedDataV2", croppedDataV2)
            console.log("check texture is here", texture)
            if (texture) {
                texture.updateMatrix();
                localTexture = texture.clone();

                // Capture the crop data from the source
                const rX = texture.repeat.x;
                const rY = texture.repeat.y;
                const oX = texture.offset.x;
                const oY = texture.offset.y;

                localTexture.wrapS = THREE.ClampToEdgeWrapping;
                localTexture.wrapT = THREE.ClampToEdgeWrapping;

                // MIRROR MATH: Flip repeat and shift offset by the width of the crop
                localTexture.repeat.set(-rX, rY);
                localTexture.offset.set(oX + rX, oY);

                localTexture.center.set(0, 0);
                localTexture.rotation = 0;
                localTexture.colorSpace = THREE.SRGBColorSpace;
                
                localTexture.updateMatrix();
                localTexture.needsUpdate = true;

                console.log("check line 1595")

            }

            const matFront = new THREE.MeshStandardMaterial({
                map: localTexture,
                color: 0xffffff,
                side: THREE.DoubleSide, // Ensure it's visible from both sides
                skinning: true
            });

            const matBack = new THREE.MeshStandardMaterial({
                color: 0xeeeeee,
                side: THREE.BackSide, // Only render on the back to avoid z-fighting
                skinning: true,
                polygonOffset: true,
                polygonOffsetFactor: 2
            });

            // --- 5. Mesh & Orientation ---
            const meshFront = new THREE.SkinnedMesh(geometry, matFront);
            const meshBack = new THREE.SkinnedMesh(geometry, matBack);

            // *** CRITICAL FIX: DISABLE FRUSTUM CULLING ***
            // This prevents the mesh from disappearing when the bones move outside the original bounding box.
            meshFront.frustumCulled = false;
            meshBack.frustumCulled = false;

            meshFront.add(bones[0]);
            meshFront.bind(skeleton);
            meshBack.bind(skeleton);

            // Enable shadows (if you switch back to StandardMaterial later)
            meshFront.castShadow = true;
            meshFront.receiveShadow = true;

            const group = new THREE.Group();
            group.add(meshFront);
            group.add(meshBack);

            // Rotate to lie on floor
            // group.rotation.x = -Math.PI/2;

            // Rotate to lie on Wall
            group.rotation.x = 0;
            group.rotation.z = 0;
            group.rotation.y = Math.PI;
            group.position.y = 0.02;

            // --- 6. Staggered Animation ---
            const tracks = [];
            const timePerBone = (unrollDuration * 0.8) / segmentCount;
            console.log("check line 1647")

            for (let i = 1; i < bones.length; i++) {
                const bone = bones[i];
                const boneName = bone.name = `bone_${i}`;

                const angle = bone.userData.curlAngle;
                const qCurled = new THREE.Quaternion().setFromEuler(new THREE.Euler(angle, 0, 0));
                const qFlat = new THREE.Quaternion().setFromEuler(new THREE.Euler(0, 0, 0));

                const startTime = (i - 1) * timePerBone;
                const endTime = startTime + 0.6;

                const times = [0, startTime, endTime, unrollDuration];
                const values = [
                    qCurled.x, qCurled.y, qCurled.z, qCurled.w,
                    qCurled.x, qCurled.y, qCurled.z, qCurled.w,
                    qFlat.x, qFlat.y, qFlat.z, qFlat.w,
                    qFlat.x, qFlat.y, qFlat.z, qFlat.w
                ];

                const track = new THREE.QuaternionKeyframeTrack(`${boneName}.quaternion`, times, values);
                tracks.push(track);
                console.log("check line 1670")

            }

            const clip = new THREE.AnimationClip('Unroll', unrollDuration, tracks);
            group.userData.animationClip = clip;
            if (typeof activeAnimations !== 'undefined') {
                activeAnimations.push(clip);
                console.log("check line 1678")
            }

            return group;
        }

        function finishUnroll() {
            const viewer = document.querySelector("model-viewer");
            isUnrolling = false;
            if (unrollTimer) {
                clearTimeout(unrollTimer);
                unrollTimer = null;
            }
            viewer.pause();
            requestAnimationFrame(() => {
                viewer.currentTime = unrollDuration - 0.01;
            });
        }
        function startUnrollAnimation() {
            const viewer = document.querySelector("model-viewer");
            if (unrollTimer) {
                clearTimeout(unrollTimer);
            }
            viewer.pause();
            viewer.currentTime = 0;
            viewer.animationName = "Unroll";
            isUnrolling = true;
            viewer.play();
            unrollTimer = setTimeout(() => {
                finishUnroll();
            }, unrollDuration * 1000);
        }

        function updateModelViewer() {
            if (isUnrolling) {
                finishUnroll();
            }
            return new Promise((resolve) => {
                // exportGroup.traverse((node) => {
                //     if (node.isMesh && node.material.map && node.material.map.image instanceof HTMLCanvasElement) {
                //         // This tells the exporter: "Don't just export the reference, 
                //         // export the current pixels drawn on this canvas."
                //         node.material.map.needsUpdate = true;
                //     }
                // });
                const options = {
                    binary: true,
                    maxTextureSize: 1024,
                    animations: activeAnimations
                };

                const exporter = new THREE.GLTFExporter();

                exporter.parse(exportGroup, (glb) => {
                    const blob = new Blob([glb], { type: 'model/gltf-binary' });
                    const url = URL.createObjectURL(blob);
                    const viewer = document.querySelector('model-viewer');

                    if (hasLED) {
                        // --- LIGHTS OFF MODE ---

                        // 1. Turn off the "Sun" / Global Room Light
                        viewer.setAttribute('environment-intensity', '0');

                        // 2. Set exposure higher so the "Glow" is vivid in the dark
                        viewer.setAttribute('exposure', '0.15');

                        // 3. Make the background black (Skybox)
                        viewer.style.backgroundColor = '#000000';
                        viewer.removeAttribute('skybox-image');
                    } else {
                        // --- LIGHTS ON MODE ---
                        viewer.setAttribute('environment-intensity', '2.0');
                        viewer.setAttribute('exposure', '1.2');
                        viewer.style.backgroundColor = '#ffffff';
                    }

                    const onLoadComplete = () => {
                        // 1. Reset state
                        viewer.pause();
                        viewer.currentTime = 0;
                        console.log("Model Loaded! Available Animations:", viewer.availableAnimations);
                        // 2. Check for animations exported in the GLB
                        if (viewer.availableAnimations.length > 0) {
                            startUnrollAnimation();
                        } else {
                            // Clean up for framed mode
                            viewer.removeAttribute('animation-name');
                            viewer.autoplay = false;
                        }

                        viewer.removeEventListener('load', onLoadComplete);
                        resolve();
                    };

                    // Setup the listener BEFORE setting the source
                    viewer.addEventListener('load', onLoadComplete);
                    viewer.src = url;

                    const genBtn = document.getElementById('generate_custom_size');
                    if (genBtn) {
                        genBtn.innerText = "Generate";
                        genBtn.style.opacity = "1.0";
                        genBtn.disabled = false;
                        isGenerateBtnClicked = false;
                    }

                }, options);
            });
        }

        function addBackStand(group, frameW, frameH, depth) {
            // 1. Clear old parts if they exist (Crucial for updates!)
            const oldStand = group.getObjectByName("easel_backstand");
            if (oldStand) group.remove(oldStand);
            const oldHinge = group.getObjectByName("easel_hinge");
            if (oldHinge) group.remove(oldHinge);

            // Define the pivot point Y (top of the leg)
            const hingePivotY = (frameH / 2) - (frameH * 0.15);

            // --- PART A: The Hinge Plate (The professional detail) ---

            // Dimensions: Slightly wider than the leg, short, and thin metallic
            const standW_ref = Math.min(frameW * 0.2, 0.04); // Reference width for calculation
            const hingeW = standW_ref + 0.005; // 5mm wider than the leg
            const hingeH = 0.015;              // 1.5cm tall plate
            const hingeThick = 0.0025;         // 2.5mm thick metal

            const hingeGeo = new THREE.BoxGeometry(hingeW, hingeH, hingeThick);

            // Material: Realistic Gold metal
            const hingeMat = new THREE.MeshStandardMaterial({
                color: 0xD4AF37, // Classic Gold
                // color: 0xC0C0C0, // <-- Uncomment for Silver
                metalness: 1.0,   // Very metallic
                roughness: 0.3,   // Slightly shiny but not mirror-like
                envMapIntensity: 1.5 // Make it catch the environment light
            });

            const hinge = new THREE.Mesh(hingeGeo, hingeMat);
            hinge.name = "easel_hinge";

            // Position: Centered horizontally, centered on the pivot Y, sitting flat on the frame back
            // We subtract half hinge thickness to place it perfectly *on* the surface.
            hinge.position.set(0, hingePivotY / 2, -(depth / 2));

            // Add hinge to group first
            group.add(hinge);


            // --- PART B: The Stand Leg (Your existing logic) ---

            const standH = frameH * 0.65;
            const standW = standW_ref;
            const standThick = 0.005; // Leg is slightly thinner than hinge plate
            // console.log("backstand sizes", standW, standH, standThick)
            const standGeo = new THREE.BoxGeometry(standW, standH, standThick);

            // Shift geometry pivot to top-front edge
            standGeo.translate(0, -standH / 2, standThick / 2);

            const standMat = new THREE.MeshStandardMaterial({
                color: 0x222222, // Dark grey cardboard/wood backing look
                roughness: 0.9
            });
            const stand = new THREE.Mesh(standGeo, standMat);
            stand.name = "easel_backstand";

            // Position hinge point exactly at the back surface frame
            stand.position.set(0, hingePivotY / 2, -(depth / 2));

            // Tilt the leg out
            stand.rotation.x = 22 * (Math.PI / 180);

            group.add(stand);
        }

        // --- MAIN BUILDER FUNCTION ---
        async function buildFramedPrint() {
            resetExportGroup() // <--- Clear the "Framed" tilt and stand
            // 1. Prepare Common Dimensions
            console.log("currentConfig buildFramedPrint enter", currentConfig)
            let factor = getUnitFactor(currentConfig.unit);
            const dims = {
                imgW: currentConfig.width * factor,
                imgH: currentConfig.height * factor,
                mat1: currentConfig.mat1 * factor,
                mat2: currentConfig.mat2 * factor,
                frame: currentConfig.frameWidth * factor,
                glassThick: 0.002,
                matThick: 0.002,
                printThick: 0.0002,
                backThick: 0.005
            };

            console.log("here is the currentConfig.width", dims.frame)
            console.log("here is the currentConfig.height", dims.imgH)

            // 2. Calculate Totals
            dims.mat2W = dims.imgW + (dims.mat2 * 2);
            dims.mat2H = dims.imgH + (dims.mat2 * 2);
            dims.totalW = (dims.mat1 > 0) ? dims.imgW + (dims.mat1 * 2) : dims.imgW;
            dims.totalH = (dims.mat1 > 0) ? dims.imgH + (dims.mat1 * 2) : dims.imgH;

            // 3. Update Materials
            updateMaterials(currentConfig.hasGlass);

            // 4. Branch Logic
            // If we have a frame selected, build the framed version
            console.log("here is the dims.frame", dims.frame)
            console.log("here is the loadedFrameTexture", loadedFrameTexture)
            if (dims.frame > 0 && loadedFrameTexture) {
                if (isContourFrame) {
                    let depth = currentConfig.frameDepth * factor; // Fixed depth as per your request
                    let rabbetDepth = currentConfig.rabbetDepth * factor; // The notch depth (5/8")

                    // 2. Find the "BackSide" and the "Inner Lip"
                    const backSideZ = -(depth / 2); // Result: -0.5
                    let innerLipZ = backSideZ + rabbetDepth; // Result: +0.125 (The "Positive Place")
                    // innerLipZ = frameDepth - innerLipZ;
                    // 2. Define the stack order (Front to Back)
                    let startZ = innerLipZ;

                    buildStack(dims, startZ); // Start stack at 0
                    
                    await buildContourFrame(dims);
                } 
                // else {
                //     buildStandardFrame(dims);
                // }

                // Check if the longest side is <= 15cm (0.15m)
                // --- UNIT SENSITIVE THRESHOLD ---
                // let threshold = (unit === 'in') ? 8 : (unit === 'mm') ? 150 : 15;
                // console.log("threshold", threshold)
                // const isSmallSize = Math.max(currentConfig.width) <= threshold;
                // console.log("isSmallSize", isSmallSize)
                // if (isSmallSize) {
                //     // console.log("here is small size enter")
                //     // 2. Add the Stand
                //     const outerFrameW = dims.totalW + (dims.frame * 2);
                //     const outerFrameH = dims.totalH + (dims.frame * 2);
                //     // const totalFrameDepth = dims.frame || 0.02; 
                //     const totalFrameDepth = 1.0 * factor;
                //     addBackStand(exportGroup, outerFrameW, outerFrameH, totalFrameDepth);

                //     // 1. Angle in Radians
                //     const outerH = outerFrameH + (dims.frame * 2);
                //     const angleRad = 15 * (Math.PI / 180);

                //     // 3. Apply Rotation
                //     exportGroup.rotation.x = -angleRad;

                //     // 4. FIX THE GAP (Trigonometry)
                //     // When tilted back, the lowest point is the bottom-back corner.
                //     // We calculate the vertical distance from the center to that corner.
                //     // Formula: (HalfHeight * cos) + (HalfThickness * sin)
                //     const halfHeight = outerH / 2;
                //     const halfThick = totalFrameDepth / 2;

                //     const newY = (halfHeight * Math.cos(angleRad)) + (halfThick * Math.sin(angleRad));

                //     exportGroup.position.y = newY;

                //     // console.log(`Tilted Frame: Y adjusted to ${newY.toFixed(4)} to touch floor.`);
                // } 
                // else {
                    exportGroup.rotation.x = 0;
                    exportGroup.rotation.y = 0;
                    exportGroup.rotation.z = 0;
                    exportGroup.position.y = 0;
                // }
            }
            else{
                if (!croppedDataV2 && rawImage) {
                    croppedDataV2 = {
                        x: 0,
                        y: 0,
                        width: rawImage.naturalWidth,
                        height: rawImage.naturalHeight
                    };
                }
                // --- PRINT ONLY MODE ---
                activeAnimations = []; 
                const borderSize = currentConfig.hasBorder ? (currentConfig.printBorder * factor) : 0; 
                const paperW = dims.imgW + (borderSize * 2);
                const paperH = dims.imgH + (borderSize * 2);

                if (mats.image) mats.image.map = loadedImageTexture;
                const printTexture = (mats.image && mats.image.map) ? mats.image.map : loadedImageTexture;


                // 1. Physically bake the crop AND border onto the canvas
                applyCropToTexture(printTexture, croppedDataV2, rawImage, paperW, paperH, borderSize);

                // 2. Call function - borderSize is now 0 because the border is part of the image!
                rollingMesh = createRollingPrint(paperW, paperH, printTexture, 0);

                rollingMesh.position.set(0, paperH / 2, 0); 
                exportGroup.add(rollingMesh);

                if (rollingMesh.userData.animationClip) {
                    // A. Fix for Model-Viewer: Add to the export array
                    // This is the most important line for the GLB file!
                    activeAnimations = [rollingMesh.userData.animationClip];

                    // A. Stop old mixer if it exists
                    if (typeof mixer !== 'undefined' && mixer) {
                        mixer.stopAllAction();
                        // If mixer is a global variable, we can uncache it roughly, 
                        // but creating a NEW one below is the real fix.
                    }

                    // B. Create a NEW mixer for this specific new mesh
                    // Make sure 'mixer' is a global variable accessible by your animate loop!
                    mixer = new THREE.AnimationMixer(rollingMesh);

                    // C. Create the action
                    const action = mixer.clipAction(rollingMesh.userData.animationClip);

                    // D. Force "Run Once" settings
                    action.setLoop(THREE.LoopOnce);
                    action.clampWhenFinished = true;

                    // E. Play
                    action.play();
                }
            }

            return 0;
        }

        // --- HELPER: UPDATE MATERIALS ---
        function updateMaterials(hasGlass) {
            // console.log("hasGlass enter", hasGlass)
            if (currentConfig.hasGlass) {
                // If you want to force high-gloss on the print underneath the glass:
                mats.image.roughness = 0.0;
                mats.image.clearcoat = 1.0;
                mats.image.envMapIntensity = 1.0;

                mats.mat1Material.roughness = 0.0;
                mats.mat1Material.clearcoat = 1.0;
                mats.mat1Material.envMapIntensity = 1.0;

                mats.mat2Material.roughness = 0.0;
                mats.mat2Material.clearcoat = 1.0;
                mats.mat2Material.envMapIntensity = 1.0;

            } else {
                // Revert to Matte (Paper/Cardboard)
                mats.image.roughness = 0.6;
                mats.image.clearcoat = 0.0;
                mats.image.envMapIntensity = 0.0; // Less environment influence on matte

                mats.mat1Material.roughness = 1.0;
                mats.mat1Material.clearcoat = 0.0;

                mats.mat2Material.roughness = 1.0;
                mats.mat2Material.clearcoat = 0.0;
            }

            // Ensure shaders update
            mats.image.needsUpdate = true;
            mats.mat1Material.needsUpdate = true;
            mats.mat2Material.needsUpdate = true;
        }

        // --- OPTION A: STANDARD BOX FRAME (Your "Perfect" Logic) ---
        function buildStandardFrame(dims) {

            let factor = getUnitFactor(currentConfig.unit);

            // console.log("hasFrame is", hasFrame)
            if (hasFrame) {
                // 2. Build Frame (Using createMiteredBar)
                let depth = currentConfig.frameDepth * factor; // Fixed depth as per your request
                let rabbetDepth = currentConfig.rabbetDepth * factor; // The notch depth (5/8")

                // 2. Find the "BackSide" and the "Inner Lip"
                const backSideZ = -(depth / 2); // Result: -0.5
                let innerLipZ = backSideZ + rabbetDepth; // Result: +0.125 (The "Positive Place")
                // innerLipZ = frameDepth - innerLipZ;
                // 2. Define the stack order (Front to Back)
                let startZ = innerLipZ;

                console.log("Material Emissive Intensity:", mats.image.emissiveIntensity);
                console.log("Texture Offset:", mats.image.map.offset);

                buildStack(dims, startZ, backSideZ); // Start stack at 0
                // Align frame center to stack center (roughly)
                // Or keep your "perfect" logic which centered it at 0
                const frameZ = 0;

                // Top
                const top = new THREE.Mesh(createMiteredBar(dims.totalW, dims.frame, depth), mats.frame);
                top.position.set(0, dims.totalH / 2, frameZ);
                exportGroup.add(top);

                // Bottom
                const bot = top.clone();
                bot.rotation.z = Math.PI;
                bot.position.set(0, -dims.totalH / 2, frameZ);
                exportGroup.add(bot);

                // Right
                const right = new THREE.Mesh(createMiteredBar(dims.totalH, dims.frame, depth), mats.frame);
                right.rotation.z = -Math.PI / 2;
                right.position.set(dims.totalW / 2, 0, frameZ);
                exportGroup.add(right);

                // Left
                const left = right.clone();
                left.rotation.z = Math.PI / 2;
                left.position.set(-dims.totalW / 2, 0, frameZ);
                exportGroup.add(left);
            } else {
                buildStack(dims, 0);
            }

        }

        async function buildContourFrame(d) {
            let factor = getUnitFactor(currentConfig.unit);

            // 1. DIMENSIONS
            const artW = d.totalW || d.w; 
            const artH = d.totalH || d.h;
            const frameWidth = d.frame || (currentConfig.frameWidth * factor);
            const frameDepth = currentConfig.frameDepth * factor;
            const backSideZ = -(frameDepth / 2);

            // 2. TEXTURE SCALING CONFIGURATION
            // If your 1175px texture represents 12 inches of wood:
            // const TEXTURE_PHYSICAL_LENGTH = 12 * 0.0254; // Convert 12" to meters (approx 0.3048m)

            const applyTiling = (texture, physicalLength) => {
                texture.wrapS = texture.wrapT = THREE.MirroredRepeatWrapping;
                // Maintain the same pixel density across all sizes
                // const TEXTURE_PHYSICAL_LENGTH = 0.6;
                const textureHeightInInches = 10; 
                const textureHeightInMeters = textureHeightInInches * 0.0254;
                const repeatCount = physicalLength / textureHeightInMeters;
                texture.repeat.set(-1, 1);
                texture.offset.set(1, Math.random());
                // texture.offset.y = Math.random();
                // CRITICAL: Prevent blurriness at sharp angles
                texture.anisotropy = 16; 
                texture.needsUpdate = true;
            };

            // 3. BACKING BOARD
            const backingThickness = 0.003; 
            const backing = new THREE.Mesh(
                new THREE.BoxGeometry(artW + 0.009, artH + 0.009, backingThickness), 
                mats.backing
            );
            backing.position.z = backSideZ + (backingThickness / 2);
            backing.name = "frame_backing_layer"; 
            exportGroup.add(backing);

            // 4. ASYNC LOADING
            const cont_textureLoader = new THREE.TextureLoader();
            const loadTex = (url) => new Promise(res => cont_textureLoader.load(url, res, undefined, () => res(null)));

            const [woodTexture, plainTexture] = await Promise.all([
                loadTex(frameFrontTexture), 
                loadTex(frameSideTexture)  
            ]);

            if (!woodTexture || !plainTexture) return;

            // 5. PREPARE ORIENTED TEXTURES
            // Horizontal Bars (Top/Bottom)
            const horizFront = woodTexture.clone();
            const horizSide = plainTexture.clone();
            applyTiling(horizFront, artW);
            applyTiling(horizSide, artW);

            // Vertical Bars (Left/Right)
            const vertFront = woodTexture.clone();
            const vertSide = plainTexture.clone();
            applyTiling(vertFront, artH);
            applyTiling(vertSide, artH);

            // 6. MATERIALS
            // Group 0: Side/Plain | Group 1: Front/Wood
            const horizMat = [
                new THREE.MeshStandardMaterial({ map: horizSide, roughness: 0.5, metalness: 0.1, side: THREE.DoubleSide }),
                new THREE.MeshStandardMaterial({ map: horizFront, roughness: 0.5, metalness: 0.1, side: THREE.DoubleSide })
            ];

            const vertMat = [
                new THREE.MeshStandardMaterial({ map: vertSide, roughness: 0.5, metalness: 0.1, side: THREE.DoubleSide }),
                new THREE.MeshStandardMaterial({ map: vertFront, roughness: 0.5, metalness: 0.1, side: THREE.DoubleSide })
            ];

            // 7. ASSEMBLY
            const overlap = 0.002; 
            const frameInnerW = artW - overlap;
            const frameInnerH = artH - overlap;

            // Top & Bottom
            const topGeo = createContourBar(frameInnerW, FRAME_PROFILE, d.frame, frameDepth);
            const top = new THREE.Mesh(topGeo, horizMat);
            top.rotation.set(-Math.PI / 2, -Math.PI / 2, 0);
            top.position.set(0, frameInnerH / 2, 0);
            exportGroup.add(top);

            const bot = top.clone();
            bot.material = horizMat; // Ensure material is applied to clone
            bot.rotation.set(-Math.PI / 2, Math.PI / 2, 0);
            bot.position.y = -frameInnerH / 2;
            exportGroup.add(bot);

            // Left & Right
            const sideGeo = createContourBar(frameInnerH, FRAME_PROFILE, d.frame, frameDepth);
            const right = new THREE.Mesh(sideGeo, vertMat);
            right.rotation.set(-Math.PI / 2, 0, 0);
            right.position.set(frameInnerW / 2, 0, 0);
            exportGroup.add(right);

            const left = right.clone();
            left.material = vertMat;
            left.rotation.set(Math.PI / 2, 0, Math.PI);
            left.position.x = -frameInnerW / 2;
            exportGroup.add(left);
        }

        function buildStack(d, startZ) {
            let factor = getUnitFactor(currentConfig.unit);
            // 1. IMAGE (The Anchor)
            // We keep the image at the reference 'startZ' so it stays at the focal plane
            console.log("here is the d for dims", d)
            const paperBackMat = new THREE.MeshStandardMaterial({
                color: 0xffffff, roughness: 1.0, side: THREE.DoubleSide
            });
            console.log("here is the mats.image", mats.image)
            const imgMaterials = [paperBackMat, paperBackMat, paperBackMat, paperBackMat, mats.image, paperBackMat];

            const rabbetWidth = currentConfig.rabbetWidth * factor;
            console.log("here is the rabbetWidth", rabbetWidth)
            d.imgW = d.imgW + rabbetWidth;
            d.imgH = d.imgH + rabbetWidth;
            const imgMesh = new THREE.Mesh(new THREE.BoxGeometry(d.imgW, d.imgH, d.printThick), imgMaterials);
            imgMesh.name = 'mainImage'
            imgMesh.position.z = startZ - (d.printThick / 2);
            // imgMesh.visible = false;
            exportGroup.add(imgMesh);

            // --- BUILD BACKWARDS (Behind Image) ---
            // Current Z starts at the back of the print
            let currentBackZ = startZ - d.printThick;

            // 2. INNER MAT (Mat 2)
            // Placed behind the image
            if (d.mat1 > 0 && d.mat2 > 0) {
                const mat2Mesh = new THREE.Mesh(new THREE.BoxGeometry(d.mat2W, d.mat2H, d.matThick), mats.mat2Material);
                // Position center: Current Back Face - Half Mat Thickness
                mat2Mesh.position.z = currentBackZ - (d.matThick / 2);
                exportGroup.add(mat2Mesh);
                currentBackZ -= d.matThick; // Move reference back
            }

            // 3. OUTER MAT (Mat 1)
            // Placed behind Mat 2 (or Image)
            if (d.mat1 > 0) {
                const matMesh = new THREE.Mesh(new THREE.BoxGeometry(d.totalW, d.totalH, d.matThick), mats.mat1Material);
                matMesh.position.z = currentBackZ - (d.matThick / 2);
                exportGroup.add(matMesh);
                currentBackZ -= d.matThick;
            }

            // 4. BACKING BOARD
            // Placed behind everything
            // if (hasFrame) {
            //     const backing = new THREE.Mesh(new THREE.BoxGeometry(d.totalW, d.totalH, d.backThick), mats.backing);
            //     backing.position.z = backSideZ + d.backThick;
            //     exportGroup.add(backing);
            // }

            // 5. GLASS
            // Placed in front of the image
            if (currentConfig.hasGlass) {
                // Add a tiny gap (0.005) so glass doesn't "Z-fight" (flicker) with the print
                const glassGap = 0.005;
                const glassZ = startZ + glassGap;

                const glass = new THREE.Mesh(new THREE.BoxGeometry(d.totalW, d.totalH, d.glassThick), mats.glass);
                glass.position.z = glassZ + (d.glassThick / 2);
                exportGroup.add(glass);
            }
        }

        function createMiteredBar(len, thick, depth) {
            const s = new THREE.Shape();
            s.moveTo(-len / 2, 0); s.lineTo(len / 2, 0); s.lineTo(len / 2 + thick, thick);
            s.lineTo(-len / 2 - thick, thick); s.lineTo(-len / 2, 0);
            const geo = new THREE.ExtrudeGeometry(s, { steps: 1, depth: depth, bevelEnabled: false });
            geo.translate(0, 0, -depth / 2);
            const pos = geo.attributes.position; const uv = geo.attributes.uv;
            for (let i = 0; i < pos.count; i++) {
                const u = (pos.getX(i) + (len / 2 + thick)) / (len + thick * 2);
                const v = (pos.getY(i) + pos.getZ(i)) / (thick + depth);
                uv.setXY(i, u, v);
            }
            geo.attributes.uv.needsUpdate = true;
            return geo;
        }

        function buildCanvasPrint() {
            resetExportGroup(); // Clear the "Framed" tilt and stand
            let factor = getUnitFactor(currentConfig.unit);
            const w = currentConfig.width * factor;
            const h = currentConfig.height * factor;
            const depth = currentConfig.canvasWrapThick * factor || 1 * factor;

            // --- 1. DETERMINE TEXTURE SOURCE ---
            let activeTexture;
            let wrapColor = '#000000'; // Default black

            // Determine Wrap Type and Parse Colors
            let wrapType = currentConfig.wrap || 'mirror';
            if (wrapType.startsWith('color_')) {
                const parts = wrapType.split('_');
                wrapColor = parts[1] || '#ffffff';
                wrapType = 'color';
            }

            // Generate the special canvas texture that includes sides
            console.log("here we have the raw image", rawImage)
            activeTexture = generateCanvasTexture(rawImage, wrapType, wrapColor);
            if (!activeTexture) return 0;

            // --- 2. MAP TEXTURE (UV SLICING) ---
            // We must slice based on the pixel ratios of the GENERATED canvas
            const canvasElement = activeTexture.image;
            const totalW_Px = canvasElement.width;
            const totalH_Px = canvasElement.height;

            // The front face width/height in pixels inside that canvas
            const hasCrop = typeof croppedDataV2 !== 'undefined' && croppedDataV2.width;
            const sw = hasCrop ? croppedDataV2.width : rawImage.width;
            const sh = hasCrop ? croppedDataV2.height : rawImage.height;

            // The depth in pixels
            const depthPx = (totalW_Px - sw) / 2;

            const getSideTexture = (side) => {
                const tex = activeTexture.clone();
                tex.colorSpace = THREE.SRGBColorSpace;
                tex.needsUpdate = true;

                // Calculate UV Ratios relative to the GENERATED canvas size
                const frontU = sw / totalW_Px;
                const frontV = sh / totalH_Px;
                const sideU = depthPx / totalW_Px;
                const sideV = depthPx / totalH_Px;

                // Start coordinates for the front face (after the left/bottom depth)
                const startX = depthPx / totalW_Px;
                const startY = depthPx / totalH_Px;

                switch (side) {
                    case 'front':
                        tex.offset.set(startX, startY);
                        tex.repeat.set(frontU, frontV);
                        break;
                    case 'right':
                        tex.offset.set(startX + frontU, startY);
                        tex.repeat.set(sideU, frontV);
                        break;
                    case 'left':
                        tex.offset.set(0, startY);
                        tex.repeat.set(sideU, frontV);
                        break;
                    case 'top':
                        tex.offset.set(startX, startY + frontV);
                        tex.repeat.set(frontU, sideV);
                        break;
                    case 'bottom':
                        tex.offset.set(startX, 0);
                        tex.repeat.set(frontU, sideV);
                        break;
                }
                tex.updateMatrix();
                return tex;
            };

            const commonMatSettings = { roughness: 0.8, side: THREE.DoubleSide };

            const materials = [
                new THREE.MeshStandardMaterial({ ...commonMatSettings, map: getSideTexture('right') }),
                new THREE.MeshStandardMaterial({ ...commonMatSettings, map: getSideTexture('left') }),
                new THREE.MeshStandardMaterial({ ...commonMatSettings, map: getSideTexture('top') }),
                new THREE.MeshStandardMaterial({ ...commonMatSettings, map: getSideTexture('bottom') }),
                new THREE.MeshStandardMaterial({ ...commonMatSettings, map: getSideTexture('front') }),
                new THREE.MeshBasicMaterial({ color: 0x000000, transparent: true, opacity: 0, side: THREE.DoubleSide }) // Back
            ];

            const geo = new THREE.BoxGeometry(w, h, depth);
            const canvasMesh = new THREE.Mesh(geo, materials);
            exportGroup.add(canvasMesh);

            // --- 3. WOOD STRETCHER FRAME & CLOTH ---
            const woodWidth = 0.015;
            const woodThick = depth - 0.001;
            const woodMat = new THREE.MeshStandardMaterial({ color: 0xDEB887, roughness: 0.6, side: THREE.DoubleSide });
            const woodZ = (-depth / 2) + (woodThick / 2);

            const innerW = w - 0.004;
            const innerH = h - 0.004;

            // Bars
            const topBar = new THREE.Mesh(new THREE.BoxGeometry(innerW, woodWidth, woodThick), woodMat);
            topBar.position.set(0, (innerH / 2) - (woodWidth / 2), woodZ);
            exportGroup.add(topBar);

            const botBar = topBar.clone();
            botBar.position.y = -((innerH / 2) - (woodWidth / 2));
            exportGroup.add(botBar);

            const sideH = innerH - (woodWidth * 2);
            const leftBar = new THREE.Mesh(new THREE.BoxGeometry(woodWidth, sideH, woodThick), woodMat);
            leftBar.position.set(-(innerW / 2) + (woodWidth / 2), 0, woodZ);
            exportGroup.add(leftBar);

            const rightBar = leftBar.clone();
            rightBar.position.x = (innerW / 2) - (woodWidth / 2);
            exportGroup.add(rightBar);

            // Cloth
            const clothPlane = new THREE.Mesh(new THREE.PlaneGeometry(innerW, innerH), 
                new THREE.MeshStandardMaterial({ color: 0xcccccc, roughness: 1.0, side: THREE.DoubleSide }));
            clothPlane.position.z = (depth / 2) - 0.005;
            clothPlane.rotation.y = Math.PI;
            exportGroup.add(clothPlane);

            return depth;
        }

        function generateCanvasTexture(img, type, wrapColor) {
            if (!img) return null;
            let factor = getUnitFactor(currentConfig.unit);

            // 1. GET CROP COORDINATES
            const hasCrop = typeof croppedDataV2 !== 'undefined' && croppedDataV2.width;
            const sx = hasCrop ? croppedDataV2.x : 0;
            const sy = hasCrop ? croppedDataV2.y : 0;
            const sw = hasCrop ? croppedDataV2.width : img.width;
            const sh = hasCrop ? croppedDataV2.height : img.height;

            const physW = currentConfig.width * factor;
            const physD = 1 * factor; // Depth

            // Scale based on the width of the cropped area
            const pixelsPerCm = sw / physW;
            const depthPx = Math.ceil(physD * pixelsPerCm);

            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            canvas.width = sw + (depthPx * 2);
            canvas.height = sh + (depthPx * 2);

            // --- NEW: NORMAL WRAP (IMAGE STRETCH) ---
            if (type === 'normal') {
                // We draw the image to fill the ENTIRE canvas area
                // This causes the edges of the image to bleed onto the sides of the 3D box
                ctx.drawImage(img, sx, sy, sw, sh, 0, 0, canvas.width, canvas.height);
            }
            else{
                // Background for color wraps
                if (type === 'color') {
                    ctx.fillStyle = wrapColor;
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                }

                // 2. Draw Center Image (The Crop)
                ctx.drawImage(img, sx, sy, sw, sh, depthPx, depthPx, sw, sh);

                // 3. Mirror Logic
                if (type === 'mirror') {
                    const drawFlip = (fsx, fsy, fsw, fsh, dx, dy, dw, dh, scaleX, scaleY) => {
                        ctx.save();
                        ctx.translate(dx + (scaleX === -1 ? dw : 0), dy + (scaleY === -1 ? dh : 0));
                        ctx.scale(scaleX, scaleY);
                        ctx.drawImage(img, sx + fsx, sy + fsy, fsw, fsh, 0, 0, dw, dh);
                        ctx.restore();
                    };

                    // Mirror edges using cropped source
                    drawFlip(0, 0, sw, depthPx, depthPx, 0, sw, depthPx, 1, -1); // Top
                    drawFlip(0, sh - depthPx, sw, depthPx, depthPx, canvas.height - depthPx, sw, depthPx, 1, -1); // Bottom
                    drawFlip(0, 0, depthPx, sh, 0, depthPx, depthPx, sh, -1, 1); // Left
                    drawFlip(sw - depthPx, 0, depthPx, sh, canvas.width - depthPx, depthPx, depthPx, sh, -1, 1); // Right

                    // Corners
                    ctx.drawImage(canvas, depthPx, depthPx, 1, 1, 0, 0, depthPx, depthPx);
                    ctx.drawImage(canvas, depthPx + sw - 1, depthPx, 1, 1, depthPx + sw, 0, depthPx, depthPx);
                    ctx.drawImage(canvas, depthPx, depthPx + sh - 1, 1, 1, 0, depthPx + sh, depthPx, depthPx);
                    ctx.drawImage(canvas, depthPx + sw - 1, depthPx + sh - 1, 1, 1, depthPx + sw, depthPx + sh, depthPx, depthPx);
                }
            }

            const tex = new THREE.CanvasTexture(canvas);
            tex.colorSpace = THREE.SRGBColorSpace;
            tex.minFilter = THREE.LinearFilter;
            tex.magFilter = THREE.LinearFilter;

            return tex;
        }

        function buildAcrylicPrint() {
            resetExportGroup(); 
            let factor = getUnitFactor(currentConfig.unit);
            const w = currentConfig.width * factor;
            const h = currentConfig.height * factor;
            const depth = 0.5 * factor; // Acrylic thickness
            const imgThickness = 0.2 * factor; // Make image paper very thin to avoid bulk

            // --- 2. IMAGE LAYER (Back Mounted) ---
            const whiteBackingMat = new THREE.MeshBasicMaterial({ color: 0x000000 }); // Changed to white for realism
            
            const imgMaterials = [
                whiteBackingMat, // Right
                whiteBackingMat, // Left
                whiteBackingMat, // Top
                whiteBackingMat, // Bottom
                mats.image,      // FRONT (Facing through the glass)
                whiteBackingMat  // BACK
            ];

            const imgMesh = new THREE.Mesh(new THREE.BoxGeometry(w, h, imgThickness), imgMaterials);

            // POSITION FIX: 
            // Back of acrylic is at -depth/2. 
            // We move the image center further back so its FRONT face touches the acrylic BACK face.
            imgMesh.position.z = -(depth / 2) - (imgThickness / 2) - 0.001; // Tiny 0.001 gap prevents Z-fighting
            imgMesh.renderOrder = 1; // Renders BEFORE the glass so it's visible through it
            exportGroup.add(imgMesh);

            // --- 1. ACRYLIC BLOCK (Clear Glass) ---
            // We add this first but give it a HIGHER renderOrder
            const block = new THREE.Mesh(new THREE.BoxGeometry(w, h, depth), mats.glass);
            block.position.z = 0;
            block.renderOrder = 2; // Renders AFTER the image
            exportGroup.add(block);

            // --- 3. STANDOFF BOLTS ---
            if (!currentConfig.floater) {
                const boltPositions = [
                    { x: w / 2 - 0.02, y: h / 2 - 0.02 }, { x: -w / 2 + 0.02, y: h / 2 - 0.02 },
                    { x: w / 2 - 0.02, y: -h / 2 + 0.02 }, { x: -w / 2 + 0.02, y: -h / 2 + 0.02 }
                ];
                const totalThickness = depth + imgThickness + 0.01; // The total "sandwich" height
                boltPositions.forEach(pos => {
                    // 1. Make the bolt exactly as long as the sandwich + a tiny bit for the cap
                    const boltGeo = new THREE.CylinderGeometry(0.01, 0.01, totalThickness + 0.002, 32);
                    const bolt = new THREE.Mesh(boltGeo, mats.chrome);
                    
                    bolt.rotation.x = Math.PI / 2;

                    // 2. Center the bolt exactly in the middle of the whole sandwich
                    // The glass is at 0, the image is at -depth/2. 
                    // Shift the bolt slightly back so it covers both.
                    bolt.position.set(pos.x, pos.y, -(imgThickness / 2)); 
                    
                    bolt.renderOrder = 3;
                    exportGroup.add(bolt);
                });
            }

            return depth;
        }

        function generateNoiseTexture(size, intensity) {
            const canvas = document.createElement('canvas');
            canvas.width = canvas.height = size;
            const ctx = canvas.getContext('2d');
            const imgData = ctx.createImageData(size, size);

            for (let i = 0; i < imgData.data.length; i += 4) {
                // Normal maps use RGB to represent X, Y, Z directions
                // We randomize X and Y (R and G) to create the "pebble" effect
                const r = 128 + (Math.random() - 0.5) * 255 * intensity;
                const g = 128 + (Math.random() - 0.5) * 255 * intensity;
                const b = 255; // Blue channel stays high for "upward" facing surface

                imgData.data[i] = r;         // Red
                imgData.data[i + 1] = g;     // Green
                imgData.data[i + 2] = b;     // Blue
                imgData.data[i + 3] = 255;   // Alpha (Full Opacity)
            }

            ctx.putImageData(imgData, 0, 0);
            
            const tex = new THREE.CanvasTexture(canvas);
            tex.wrapS = tex.wrapT = THREE.RepeatWrapping; // Critical for tiling
            return tex;
        }

        function createRoundedRectShape(width, height, radius) {
            const shape = new THREE.Shape();
            const x = -width / 2;
            const y = -height / 2;

            shape.moveTo(x, y + radius);
            shape.lineTo(x, y + height - radius);
            shape.quadraticCurveTo(x, y + height, x + radius, y + height);
            shape.lineTo(x + width - radius, y + height);
            shape.quadraticCurveTo(x + width, y + height, x + width, y + height - radius);
            shape.lineTo(x + width, y + height - radius);
            shape.lineTo(x + width, y + radius);
            shape.quadraticCurveTo(x + width, y, x + width - radius, y);
            shape.lineTo(x + radius, y);
            shape.quadraticCurveTo(x, y, x, y + radius);
            return shape;
        }

        const silvertextureCache = {};

        async function getSilverTexture() {
            
            if (silvertextureCache[silverTextureUrl]) return silvertextureCache[silverTextureUrl];

            const loader = new THREE.TextureLoader();
            const texture = await new Promise((resolve, reject) => {
                loader.load(silverTextureUrl, resolve, undefined, reject);
                console.log("metal print 2782", resolve)
            });

            texture.colorSpace = THREE.SRGBColorSpace;
            texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
            texture.repeat.set(1, 0.2)
            silvertextureCache[silverTextureUrl] = texture;
            console.log("metal print 2695")
            return texture;
        }

        function getLBracketShape(size) {
            const shape = new THREE.Shape();
            const thickness = size * 0.4; // Thickness of the L arms

            // Start at the outer corner (bottom-left)
            shape.moveTo(0, 0);
            // Move to outer bottom-right
            shape.lineTo(size, 0);
            // Move to inner "step"
            shape.lineTo(size, thickness);
            shape.lineTo(thickness, thickness);
            shape.lineTo(thickness, size);
            // Move to outer top-left
            shape.lineTo(0, size);
            // Close the shape
            shape.lineTo(0, 0);

            return shape;
        }

        async function buildMetalPrint(startZ = 0) {
            // resetExportGroup();
            let factor = getUnitFactor(currentConfig.unit);
            const w = currentConfig.width * factor;
            const h = currentConfig.height * factor;
            const depth = 0.004; 

            // 1. Get Texture from Cache
            const silverTexture = await getSilverTexture();
            // --- 2. MATERIAL DEFINITION ---
            const rawAluminumMat = new THREE.MeshStandardMaterial({
                map: silverTexture,
                color: 0xc4c4c4,
                roughness: 0.15,
                metalness: 0.6,
                side: THREE.DoubleSide
            });
            const silverHardwareMat = new THREE.MeshStandardMaterial({ 
                color: 0xcccccc, 
                metalness: 1.0, 
                roughness: 0.2,
                side: THREE.DoubleSide
            });
            const isFramed = currentConfig.type === 'floaterFrame' || currentConfig.type === 'framed';
            const type = currentConfig.metalFinish ? currentConfig.metalFinish.toLowerCase() : '';

            // --- 1. DEFINE FINISH SETTINGS ---
            let finishSettings = {
                color: 0xffffff,
                roughness: 0.2,
                metalness: 0.1,
                opacity: 1.0,
                useTexture: false
            };

            if (type.includes('white gloss')) {
                finishSettings = { color: 0xffffff, roughness: 0.05, metalness: 0.0 };
            } else if (type.includes('white matte')) {
                finishSettings = { color: 0xffffff, roughness: 0.8, metalness: 0.0 };
            } else if (type.includes('white satin')) {
                finishSettings = { color: 0xffffff, roughness: 0.15, metalness: 0.2 };
            } else if (type.includes('silver gloss')) {
                // Silver makes the "white" in the photo look like metal
                finishSettings = { color: 0xcccccc, roughness: 0.15, metalness: 0.6 };
            } else if (type.includes('outdoor hd')) {
                // Usually extremely glossy and high contrast
                finishSettings = { color: 0xffffff, roughness: 0.01, metalness: 0.0 };
            }

            // --- 2. APPLY TO FRONT MATERIAL ---
            const frontMat = mats.metal.clone();
            frontMat.map = loadedImageTexture;
            frontMat.emissiveMap = loadedImageTexture; // Ensure crop carries to emissive
            frontMat.color.setHex(finishSettings.color);
            frontMat.roughness = finishSettings.roughness;
            frontMat.metalness = finishSettings.metalness;

            // --- TEXTURE MATTE ADJUSTMENTS ---
            if (type.includes('texture matte')) {
                frontMat.roughness = 1.0; // Complete matte
                frontMat.metalness = 0.0; // No metallic reflection
                
                // Generate and apply the noise/grain
                const noiseTexture = generateNoiseTexture(256, 1); // size, intensity
                noiseTexture.wrapS = noiseTexture.wrapT = THREE.RepeatWrapping;
                
                // Scale the noise based on the physical size of the print
                // Higher numbers = smaller, finer grain
                const noiseScale = 30; 
                noiseTexture.repeat.set(w * noiseScale, h * noiseScale);
                
                frontMat.normalMap = noiseTexture;
                frontMat.normalScale.set(2.0, 2.0); // Adjust this (0.1 to 2.0) for "bump" depth
            }

            const panelMaterials = [
                silverHardwareMat, silverHardwareMat, silverHardwareMat, 
                silverHardwareMat, frontMat, silverHardwareMat
            ];

            const mesh = new THREE.Mesh(new THREE.BoxGeometry(w, h, depth), panelMaterials);
            console.log("mesh position is metalPrint", startZ - (depth / 2))
            mesh.position.set(0, 0, startZ - (depth / 2));
            exportGroup.add(mesh);

            const whiteBackingMat = new THREE.MeshStandardMaterial({
                color: 0xffffff, // Pure white
                roughness: 0.9,  // Matte finish
                metalness: 0.0,  // Non-metallic
                side: THREE.DoubleSide
            });

            const matteBlackMat = new THREE.MeshStandardMaterial({ 
                color: 0x111111, 
                roughness: 0.8,
                side: THREE.DoubleSide
            });

            const matteGoldMat = new THREE.MeshStandardMaterial({ 
                color: 0xB8860B, 
                roughness: 0.8,
                side: THREE.DoubleSide
            });
            
            
            

            // A clean, matte white material for the mounting blocks
            if (currentConfig.backMountType === 'Tape' && !isFramed) {    
                if (!currentConfig.floater) {
                    const floatDepth = 0.002; 
                    const blockW = w * 0.5;
                    const blockH = h * 0.08; // Made blocks shorter to fit two on the back
                    
                    // Create Top Block
                    const floatBlockTop = new THREE.Mesh(
                        new THREE.BoxGeometry(blockW, blockH, floatDepth), 
                        whiteBackingMat
                    );
                    // Position: Move to the top 25% of the height
                    floatBlockTop.position.y = h * 0.25;
                    floatBlockTop.position.z = (-depth) - (floatDepth / 2);
                    exportGroup.add(floatBlockTop);

                    // Create Bottom Block (Next to/Below the first)
                    const floatBlockBottom = floatBlockTop.clone();
                    // Position: Move to the bottom 25% of the height
                    floatBlockBottom.position.y = -h * 0.25;
                    exportGroup.add(floatBlockBottom);
                }
            }

            if (currentConfig.backMountType === 'Float Mount' && !isFramed) {
                const floatDepth = 0.020; 
                
                // --- Block 1: Standard Inner Block ---
                const floatBlock = new THREE.Mesh(
                    new THREE.BoxGeometry(w * 0.4, h * 0.4, floatDepth), 
                    matteGoldMat
                );
                floatBlock.position.z = (-depth / 2) - (floatDepth / 2);
                exportGroup.add(floatBlock);

                // --- Block 2: Rounded Outer Plate ---
                const floatDepth1 = 0.002; 
                const plateW = w * 0.7;
                const plateH = h * 0.7;
                const cornerRadius = 0.01; // Adjust this value for more/less roundness

                // Create rounded geometry
                const plateShape = createRoundedRectShape(plateW, plateH, cornerRadius);
                const plateGeo = new THREE.ExtrudeGeometry(plateShape, {
                    depth: floatDepth1,
                    bevelEnabled: false
                });

                const floatBlock1 = new THREE.Mesh(plateGeo, rawAluminumMat);

                // POSITIONING: 
                // floatBlock ends at: (-depth/2) - floatDepth
                // We place the FRONT of floatBlock1 at that exact Z position.
                // ExtrudeGeometry builds forward along Z, so we subtract the full depth.
                floatBlock1.position.z = (-depth / 2) - floatDepth - floatDepth1;
                
                exportGroup.add(floatBlock1);
            }
            if (currentConfig.backMountType === 'standoffs' && !isFramed) {
                const postRadius = 0.01; // ~1/2 inch wide
                const postDepth = 0.025; // ~1 inch off wall
                const inset = 0.02;     // Distance from corner

                const postGeo = new THREE.CylinderGeometry(postRadius, postRadius, postDepth, 16);
                // Rotate so cylinder points toward wall (Z-axis)
                postGeo.rotateX(Math.PI / 2);

                const cornerPositions = [
                    { x: (w/2) - inset, y: (h/2) - inset },  // Top Right
                    { x: -(w/2) + inset, y: (h/2) - inset }, // Top Left
                    { x: (w/2) - inset, y: -(h/2) + inset }, // Bottom Right
                    { x: -(w/2) + inset, y: -(h/2) + inset } // Bottom Left
                ];

                cornerPositions.forEach(pos => {
                    const post = new THREE.Mesh(postGeo, rawAluminumMat);
                    post.position.set(pos.x, pos.y, (-depth / 2) - (postDepth / 2));
                    exportGroup.add(post);
                });
            }
            // --- 5. CORRECTED EXTRUDED SUBFRAME ---
            if (currentConfig.backMountType === 'Aluminum' && !isFramed) {
                // 1. Get the custom Shape from your SVG path
                const svgPathData = AluMountProfile;

                const targetWidth = 0.025; 
                const targetDepth = 0.015; 
                const inset = 0.07; 
                const subW = w - (inset * 2);
                const subH = h - (inset * 2);

                // Use an array for materials because createContourBar creates 2 groups
                const subFramemats = [matteBlackMat, matteBlackMat];

                const frameGroup = new THREE.Group();

                const plateBackZ = startZ - depth;
                const dynamicMountZ = plateBackZ - (targetDepth / 2);
                console.log("here is the dynamicMountZ", dynamicMountZ)
                // --- Horizontal Bars ---
                const topBarGeo = createContourBar(subW, svgPathData, targetWidth, targetDepth);
                const topBar = new THREE.Mesh(topBarGeo, subFramemats); // Wrap in Mesh
                topBar.rotation.set(-Math.PI / 2, -Math.PI / 2, 0);
                topBar.position.set(0, (h / 2) - inset, dynamicMountZ);
                
                const bottomBar = topBar.clone();
                bottomBar.rotation.set(-Math.PI / 2, Math.PI / 2, 0);
                bottomBar.position.y = -(h / 2) + inset;
                bottomBar.position.z = dynamicMountZ;

                // --- Vertical Bars (Fixed: Uses subH) ---
                const leftBarGeo = createContourBar(subH, svgPathData, targetWidth, targetDepth);
                const leftBar = new THREE.Mesh(leftBarGeo, subFramemats); // Wrap in Mesh
                leftBar.rotation.set(Math.PI / 2, 0, Math.PI);
                leftBar.position.x = -(w / 2) + inset;
                leftBar.position.z = dynamicMountZ;


                const rightBar = leftBar.clone();
                rightBar.rotation.set(-Math.PI / 2, 0, 0);
                rightBar.position.x = (w / 2) - inset;
                rightBar.position.z = dynamicMountZ;
                

                frameGroup.add(topBar, bottomBar, leftBar, rightBar);
                exportGroup.add(frameGroup);

                // --- 5. DETAILED CORNER JOINING HARDWARE ---
                const bracketSize = targetWidth * 1.2; 
                const plateThickness = 0.003;
                const screwHeight = 0.0020;

                const plateGeo = new THREE.ExtrudeGeometry(getLBracketShape(bracketSize), {
                    depth: plateThickness,
                    bevelEnabled: false
                });

                const corners = [
                    { x: (subW/2), y: (subH/2), rot: Math.PI },      
                    { x: -(subW/2), y: (subH/2), rot: -Math.PI/2 },  
                    { x: -(subW/2), y: -(subH/2), rot: 0 },          
                    { x: (subW/2), y: -(subH/2), rot: Math.PI/2 }    
                ];

                corners.forEach(pos => {
                    const assembly = new THREE.Group();

                    // 1. THE L-PLATE (SILVER)
                    const plate = new THREE.Mesh(plateGeo, silverHardwareMat);
                    
                    // Positioning the L-shape corner
                    plate.position.set(-bracketSize / 1.4, -bracketSize / 1.4, 0);
                    assembly.add(plate);

                    // 2. THE SCREWS
                    const screwGeo = new THREE.CylinderGeometry(0.002, 0.002, screwHeight, 16);
                    // Point the screw heads toward the wall (-Z)
                    screwGeo.rotateX(-Math.PI / 2); 
                    
                    const s1 = new THREE.Mesh(screwGeo, silverHardwareMat);
                    const s2 = s1.clone();
                    
                    // The surface of the flipped plate is at -plateThickness
                    // We move the screws slightly further back so they sit ON the plate
                    const screwZ = (plateThickness / 2) - (screwHeight / 2);
                    
                    s1.position.set(-bracketSize / 1.8, bracketSize / 5.5, screwZ); 
                    s2.position.set(bracketSize / 5.5, -bracketSize / 1.8, screwZ); 
                    assembly.add(s1, s2);

                    // 3. POSITIONING THE ASSEMBLY
                    // Use your verified "Perfect Position" calculation
                    assembly.position.set(pos.x, pos.y, dynamicMountZ - (targetDepth / 4));
                    
                    // Apply the miter-joint rotation
                    assembly.rotation.z = pos.rot;
                    
                    // ADD DIRECTLY TO EXPORTGROUP to avoid double-rotation from frameGroup
                    exportGroup.add(assembly); 
                });
            }
            return depth;
        }
        
        init();

        document.querySelectorAll('variant-selects input, livearf-variant-selects input, all-variant select, all-variant select')
            .forEach(el => {
                el.addEventListener('change', function (event) {
                    const action = event.target.getAttribute('action');
                    // 1. Check if the changed element is a custom size input
                    if (action === 'custom-size-width' || action === 'custom-size-height' || event.target.id == 'liveraf-toggleSwitch') {
                        console.log("Input ignored by global listener. Waiting for 'Generate' click.");
                        return; // STOP: Exit here so selectedOptionData() doesn't run
                    }

                    // 2. Otherwise, run the normal pipeline
                    selectedOptionData(); //  Onload Initiating function
                });
            });
        selectedOptionData();
    }
}
